export default {
  "termsOfUse": "Használati feltételek",
  "choose": "Kiválasztás",
  "close": "Bezárás",
  "yes": "Igen",
  "no": "Nem",
  "send": "Küldés",
  "sendSuccess": "Küldve a",
  "other": "Egyéb",
  "or": "vagy",
  "goNext": "Folytatás",
  "save": "Mentés",
  "showAll": "Összes megtekintése",
  "saveChanges": "Változások mentése",
  "saveChangesProcess": "Tárolás",
  "saveChangesSuccess": "Retrieved from",
  "loginText": "Bejelentkezés",
  "done": "Kész",
  "skip": "Ugrás a",
  "legalDocuments": "Jogi dokumentumok",
  "pilot": "Videóhívás",
  "here": "itt",
  "subscribe": "Feliratkozás",
  "agree": "Elfogadom",
  "disagree": "Elutasítom",
  "alertInfo": {
    "title": "A Soulody.hu nem helyettesíti a segélyhívó szolgálatot.",
    "text": "Akut problém esetén hívja a 112/104-es vonalat.",
    "iAgree": "Rendben",
    "errorText": "Ez a mező kötelező."
  },
  "uLekare": {
    "title": "Soulody.hu"
  },
  "partners": {
    "otherPartners": "Partnerek"
  },
  "questionForm": {
    "next": "Folytatás",
    "firstName": {
      "title": "Keresztnév",
      "errorText": "A név kitöltése kötelező, kérjük, töltse ki.",
      "helpTextRealData": "Adja meg a valódi nevét az egészségügyi intézménnyel való kommunikációhoz."
    },
    "lastName": {
      "title": "Vezetéknév",
      "errorText": "A vezetéknév kötelező mező, kérjük, töltse ki.",
      "helpTextRealData": "Adja meg a valódi vezetéknevét az egészségügyi intézménnyel való kommunikációhoz."
    },
    "email": {
      "title": "E-mail",
      "placeholder": "nev@pelda.hu",
      "errorText": "Az e-mail cím megadása kötelező, kérjük töltse ki!",
      "errorEmailText": "Az e-mail nem helyes, kérem ellenőrizze."
    },
    "phone": {
      "title": "Telefon",
      "errorText": "A telefonszám megadása kötelező, kérjük, töltse ki.",
      "errorPhoneText": "({exampleNumber})Adja meg a telefonszámát."
    },
    "emailphone": {
      "errorEmailText": "Az e-mail cím megadása kötelező, kérjük töltse ki!",
      "errorPhoneText": "A telefonszám megadása kötelező, kérjük, töltse ki!"
    },
    "zipCode": {
      "title": "POSTACÍM"
    },
    "timeAvailability": {
      "errorText": "Kérjük, töltse ki, hogy melyik nap és időpont felel meg Önnek."
    },
    "personalId": {
      "title": "TAJ-szám"
    },
    "thankYou": {
      "title": "A kérdés elküldve.",
      "perex": "Köszönjük a kérdését, amint választ kap rá, értesíteni fogjuk."
    }
  },
  "fileUpload": {
    "initial": "Kattintással válassza ki a fájlokat vagy húzza át őket. ",
    "send": "Küldés",
    "addFiles": "Csatoljon fényképet vagy orvosi jelentéseket."
  },
  "footer": {
    "copyright": "© 2007-{thisYear} Soulody",
    "issn": "ISSN 1802-5544",
    "companyTitle": "A Soulody.hu vállalat",
    "companyList": [
      {
        "title": "Kapcsolat"
      },
      {
        "title": ""
      },
      {
        "title": ""
      },
      {
        "title": "Egészség és megelőzés a munkahelyen",
        "link": "index",
        "partnerLink": "https://soulody.hu/",
        "thematicCounsellingLink": "https://soulody.hu/",
        "target": "_blank",
        "forCompanies": "false",
        "aeskulab": "false"
      },
      {
        "title": "A személyes adatok kezelésére vonatkozó szabályzat",
        "link": "personalDataProcessing",
        "partnerLink": "thematicCounsellingPersonalDataProcessing",
        "thematicCounsellingLink": "thematicCounsellingPersonalDataProcessing",
        "forCompaniesLink": "forCompaniesPersonalDataProcessing"
      },
      {
        "title": "Felhasználási feltételek",
        "link": "termsAndConditions",
        "partnerLink": "hrbTermsAndConditions",
        "thematicCounsellingLink": "thematicCounsellingTermsAndConditions",
        "forCompaniesLink": "forCompaniesTermsAndConditions"
      },
      {
        "title": "Süti nyilatkozat",
        "link": "cookies",
        "partnerLink": "hrbCookies",
        "thematicCounsellingLink": "thematicCounsellingCookies",
        "forCompaniesLink": "forCompaniesCookies"
      }
    ],
    "perex": {
      "default": "A Soulody.hu-nál hiszünk abban, hogy az egészség az Öné. A technológia, az emberséges hozzáállás és az orvosi szakértelem segítségével segítünk az embereknek, hogy irányítsák az egészségüket. Több mint 350 orvosból álló csapatunk, akik minden szakterületet lefednek, átlagosan 15 000 kérést kezelnek havonta. Az ügyfélzóna a felhasználók számára a hét minden napján, 24 órában elérhető, nemcsak a weben, hanem mobilalkalmazáson keresztül is, és online orvosi tanácsadást, szakértői cikkeket és egészségügyi tippeket kínál, valamint bizonyos felhasználók számára lehetőséget biztosít orvosi időpontfoglalásra, illetve megelőző vizsgálatok és oltások naptárának kezelésére."
    }
  },
  "dataProcessing": {
    "iAgree": "Hozzájárulok a",
    "iAgreeWith": "Hozzájárulok a",
    "newsletterProcessing": "a Soulody.hu híreinek és kedvezményeinek értesítésév.",
    "conferenceDataTitle": "Hozzájárulok a személyes adataim kezeléséhez.",
    "privacyPolicyInAccordance": "A regisztráció befejezésével elfogadja az"
  },
  "termsAndConditions": {
    "title": "Használati feltételek"
  },
  "personalDataProcessing": {
    "title": "Hozzájárulás a személyes adatok feldolgozásához"
  },
  "newsletter": {
    "title": "Hozzájárulás a marketingközlemények küldéséhez"
  },
  "days": {
    "sunday": "Nem"
  },
  "error": {
    "400": "400-as hiba",
    "404": "Az oldal nem található",
    "500": "500-as hiba"
  },
  "meta": {
    "partnerNavigation": {
      "title": "Partner navigáció"
    },
    "cookies": {
      "title": "Cookie nyilatkozat"
    },
    "termsAndConditions": {
      "title": "Használati feltételek"
    },
    "personalDataProcessing": {
      "title": "Személyes adatok feldolgozásának alapelvei"
    },
    "emergency": {
      "title": "Mikor kell felkeresni a sürgősségi ügyeletet",
      "description": "Az akut vagy életveszélyes állapotok rövid listája, amelyre a betegeket figyelmeztetni szeretnénk, hogy a legsürgősebb eseteket a sürgősségi ellátásba irányítsuk."
    },
    "evaluation": {
      "order": {
        "title": "Orvosi látogatás értékelése",
        "description": "Orvosi látogatás értékelése"
      }
    },
    "mastercard": {
      "title": "Mastercard"
    },
    "overview": {
      "title": "Segítséget nyújtunk, időpontokat szervezünk Önnek, és elősegítjük az egészséget",
      "description": "Kérdezze meg egészségügyi szakembereinket egészségügyi problémáiról, vagy engedje, hogy azonnal időpontot kérjünk egy orvosi rendelésre. Segítünk Önnek, hogy vigyázzon az egészségére. Online, ingyenes és mindig elérhetőek vagyunk."
    },
    "hrbOrderPage": {
      "title": "Beosztjuk Önt egy orvoshoz",
      "description": "Olyan orvost keres, aki megvizsgálja Önt? Fogalma sincs, hogy milyen orvost válasszon? Bízza ránk. Egész Csehországban időpontot adunk az orvosoknak. Ez ingyenes és mindig elérhető."
    },
    "hrbQuestionPage": {
      "title": "Kérdezzen online konzultációs szobánkban",
      "description": "Bízza magát orvosainkra, 6 órán belül választ kap a testi és lelki egészséggel kapcsolatos kérdéseire. Online, ingyenesen és bármikor, amikor csak szüksége van rá."
    },
    "hrbPreventionPage": {
      "title": "Megelőzés",
      "description": "Segítünk a megelőzésben. Beszélgessen orvosainkkal egészségügyi kérdésekről, kapjon ajánlásokat a megelőzésre vonatkozóan, és ütemezze be a szükséges megelőző vizsgálatokat."
    },
    "login": {
      "title": "Bejelentkezés",
      "description": "Regisztráljon, és 350 orvos minden szakterületről elérhető közelségbe kerül. Segítünk Önnek időpontot foglalni egy orvoshoz Csehország egész területén. Az Ön egészségére."
    },
    "dashboard": {
      "title": "Egészség online"
    },
    "dashboardQuestions": {
      "title": "Tanácsadás"
    },
    "dashboardAppointments": {
      "title": "Orvosi rendelés"
    },
    "dashboardArticles": {
      "title": "Discover Magazin"
    },
    "dashboardConsultations": {
      "title": "Válaszoltak az orvosok"
    },
    "dashboardPrevention": {
      "title": "Az én megelőzésem"
    },
    "dashboardProfile": {
      "title": "Az én egészségprofilom"
    },
    "lostPassword": {
      "title": "Elfelejtett jelszó"
    },
    "passwordReset": {
      "title": "Jelszó visszaállítása"
    },
    "emailVerification": {
      "title": "Email ellenőrzés"
    },
    "registration": {
      "title": "Regisztráció"
    },
    "ePrescription": {
      "title": "Hogyan működik az eRecept a Soulody.hu-n?",
      "description": "Az e-receptekre vonatkozó szabályok..."
    }
  },
  "rsAssistant": {
    "registerForm": {
      "send": "Küldés",
      "zipCode": {
        "title": "POSTACÍM"
      }
    }
  },
  "astmaHelp": {
    "registerForm": {
      "send": "Küldés"
    }
  },
  "companies": {
    "hero": {
      "items": [
        {
          "icon": "$checkCircle",
          "iconColor": "white"
        },
        {
          "icon": "$checkCircle",
          "iconColor": "white"
        },
        {
          "icon": "$checkCircle",
          "iconColor": "white"
        }
      ]
    },
    "companyPresentation": {
      "benefitList": [
        {
          "icon": "doctor"
        },
        {
          "icon": "rodina"
        },
        {
          "icon": "clock"
        },
        {
          "icon": "phone"
        },
        {
          "icon": "globus"
        }
      ]
    },
    "contactForm": {
      "send": "Küldés"
    }
  },
  "companiesOrder": {
    "firstStep": {
      "setup": {
        "nextButton": "Folytatás az időpontfoglaláshoz"
      }
    }
  },
  "emergency": {
    "title1": "Mikor kell felkeresni a sürgősségi ügyeletet",
    "perex": "Íme egy rövid lista az akut vagy életveszélyes állapotokról, amelyekre szeretnénk felhívni a betegek figyelmét, hogy a legsürgősebbeket az ügyeletre irányítsuk, hogy ne késleltessék a kezelést azzal, hogy az orvos válaszára várnak a tanácsadóban. A legnagyobb óvatosságra a gyermekek esetében van szükség.",
    "list": [
      {
        "title": "Sérülések és vérzés",
        "body": [
          "erős vérzés, vagy élénkvörös vérzés, ami spriccel",
          "nagyon erős nemi szervi vérzés a menstruációs cikluson kívül vagy a végbélnyílásból",
          "nyílt vagy más módon nyilvánvaló törés",
          "nyílt sebek a mellkason vagy a hasüregben",
          "eszméletvesztéssel, viselkedészavarral, fejfájással, hányással, eltérő méretű pupillákkal, beszéd-, látás- vagy mozgászavarokkal járó fejsérülések",
          "égési sérülések gyermekeknél, különösen a fejen és a kezeken, a nemi szerveken, vagy felnőtteknél a test nagyobb területén",
          "áramütés vagy villámcsapás"
        ]
      },
      {
        "title": "Mellkasi fájdalom és mellkasi panaszok",
        "body": [
          "szüntelen, a hagyományos fájdalomcsillapítókra nem reagáló, vagy egyre súlyosabb és szorító mellkasi fájdalom",
          "a bal karba vagy a nyakba nyilall",
          "fájdalom vagy ritmuszavar, tudatváltozással, ájulással kísérve",
          "ha ismételten hasonló tünetei vannak, vagy ha szív- és keringési rendszer betegségben szenved",
          "légszomjjal és jelentős nyomásváltozásokkal járó mellkasi fájdalom"
        ]
      },
      {
        "title": "Légszomj",
        "body": [
          "nehéz lélegzetvétel, levegőhiány érzete",
          "ziháló légzés (mint egy hal), lihegő légzés, sípoló kilégzés",
          "lehetetlen befejezni egy mondatot belégzés nélkül, a légzés javítása érdekében le kell ülni vagy a kezekre támaszkodni, nyaküreg, valamint a vállak és a nyak közötti süllyedés",
          "az ajkak, a fülek vagy az ujjak bőrszínének ellilulása"
        ]
      },
      {
        "title": "Fejfájás",
        "body": [
          "a fájdalom erős, szokatlan, hirtelen fellépő, gyógyszeres kezelésre nem reagál",
          "éjszaka felébreszt, vagy közvetlenül ébredés után jelentkezik",
          "a hirtelen fellépő fájdalmat nagy fizikai megerőltetés előzte meg, beleértve a szexuális aktivitást is",
          "a fájdalmat nyakmerevség, rossz közérzet, álmosság, tudatzavar, láz kíséri",
          "fejfájás a fejsérülést követő napokban, különösen tudatzavarral, hányással, öklendezéssel társul",
          "látás-, beszéd- és mozgászavarral jár"
        ]
      },
      {
        "title": "Hasi fájdalom és emésztőrendszeri megnyilvánulások",
        "body": [
          "erős vagy kólikás hasi fájdalom",
          "széklet vagy gázok távozásának elmaradása hasi puffadással, fájdalommal",
          "fekete széklet",
          "<strong>vérhányás</strong>",
          "<strong>dudor a hason</strong>, ágyékon, herén, amely fáj, nem lehet benyomni (ne próbálja meg), a környező területhez képest elszíneződött"
        ]
      },
      {
        "title": "Ájulás, eszméletvesztés, görcsök",
        "body": [
          "hirtelen ájulás, elesettség, amely után a személy nem ébred fel, vagy nem viselkedik természetesen",
          "tudat-, beszéd-, látás-, végtagmozgási zavarokkal járó állapotok",
          "<strong>teljes testi görcsök</strong>"
        ]
      },
      {
        "title": "Fertőzések és láz",
        "body": [
          "40 °C feletti lázzal járó állapotok, amelyek nem enyhíthetők a gyógyszer testsúlynak megfelelő adagjával",
          "<strong>hidegrázás gyermekeknél, lázgörcsök gyermekeknél</strong>",
          "ismétlődő, nem enyhülő hányás és hasmenés gyermekeknél, elégtelen folyadékbevitel gyermekeknél",
          "általános állapotváltozással/viselkedésváltozással járó fertőzések, mint például jelentős álmosság, rossz közérzet, evés- és ivászavar"
        ]
      },
      {
        "title": "Allergiák és duzzanatok",
        "body": [
          "<strong>arc, nyak és a torok belsejének duzzanata, a nyelv duzzanata</strong>",
          "<strong>légszomj</strong>",
          "<strong>nyelési nehézség</strong>",
          "egész testre kiterjedő megnyilvánulások, mint például kiütés vagy duzzanat",
          "egyoldali, különösen fájdalmas végtagduzzanat, amelyet légszomj vagy száraz köhögés kísérhet"
        ]
      },
      {
        "title": "Fogászati sürgősségi ellátás",
        "body": [
          "Fogfájás erős fejfájással",
          "Fogfájás lázzal",
          "az arc és a fogak területének duzzanata, amely a nyakra terjed, vagy nyelési nehézség kíséri"
        ]
      },
      {
        "title": "Bűncselekmények",
        "body": [
          "ha bűncselekmény gyanúja merül fel, hívja a 112-es segélyhívószámot",
          "ha az Ön vagy közeli személy élete veszélyben van bűncselekmény következtében, hívja a 112-es segélyhívószámot",
          "ha zaklatásról, testi vagy lelki sérülésről van szó, hívja a 112-es segélyhívószámot"
        ]
      },
      {
        "title": "Lelki állapot",
        "body": [
          "amennyiben hirtelen zavartság, viselkedésváltozás, agresszivitás lép fel, hívjon mentőt",
          "amennyiben közvetlen öngyilkossági szándékról van szó, hívjon mentőt"
        ]
      }
    ],
    "title2": "Hívja a 112-es számot",
    "title": "Mikor kell felkeresni a sürgősségi ügyeletet"
  },
  "emergencyInfo": {
    "subtitle": "A Soulody.hu szolgáltatás nem helyettesíti a sürgősségi ellátást.<br /><a href=\"{link}\" target=\"_blank\" class=\"black--text link--inline\">Mikor kell felkeresni a sürgősségi ügyeletet?</a>",
    "services": "Akut, életveszélyes állapot esetén mindig hívja a <a href=\"tel:112\" class=\"link--inline black--text\">112-t vagy a 104-et</a>.",
    "continueQuestion": "A kérdés folytatása",
    "continueOrder": "Folytassa a rendelést",
    "dynamicForms": {
      "text": "A Soulody.hu nem helyettesíti a segélyhívó szolgálatot. {emergencyLink} Életveszélyes állapot esetén mindig hívja a 112/104-es telefonszámot.",
      "linkText": "Mikor kell felkeresni a sürgősségi ügyeletet"
    }
  },
  "evaluation": {
    "orderInfo": {
      "zz": "Egészségügyi intézmény"
    }
  },
  "partnerb2b": {
    "mastercard": {
      "howItWorks": {
        "items": [
          {
            "icon": "chat"
          }
        ]
      }
    }
  },
  "masterCard": {
    "howItWorks": {
      "items": [
        {
          "icon": "chat"
        }
      ]
    },
    "authorization": {
      "subtitle": {
        "question": "Szükségünk van a bankkártyája első 6 számjegyére. Nem történik pénzlevonás, a sikeres bejelentkezés után szolgáltatásunkat ingyen használhatja."
      },
      "codeLabel": ""
    }
  },
  "reauthorizationDashboard": {
    "heading": "Az ingyenes szolgáltatása {daysLeft} múlva, {dayFormat}-án/-en ér véget.",
    "partnerText": "Az Soulody.hu szolgáltatásért továbbra is Ön fizet. {currentPartnerName}."
  },
  "hrbPage": {
    "hello": {
      "title": "Az egészség felé vezető úton az Ön útmutatója vagyunk."
    },
    "hrbArticles": {
      "items": [
        {
          "params": {
            "slug": "megelőzés"
          }
        }
      ],
      "itemsVoZP": [
        {
          "params": {
            "slug": "megelőzés"
          }
        }
      ]
    },
    "faq": {
      "title": "Mi érdekel?"
    },
    "employeeStories": {
      "title": "Történetek a tanácsadónkból"
    },
    "contactUs": {
      "title": "Ügyfélvonal",
      "subTitle": "Nem tudja, mit tegyen? Segítségre van szüksége az űrlap kitöltéséhez?"
    },
    "covidLink": {
      "hours": "H-P 8:00-17:00"
    }
  },
  "authorization": {
    "title": "A szolgáltatás aktiválása",
    "emailLabel": "E-mail",
    "codeLabel": "Kód",
    "or": "vagy",
    "contactTitle": "Nem tudja, mit tegyen?",
    "final": {
      "thankYouTitle": "Szolgáltatás aktiválása",
      "thankYouSubtitle": "Minden beállítás kész.",
      "infoHeading": "Nagyszerű! Sikeres aktiválás.",
      "infoText": "Élvezze az ingyenes szolgáltatását\nteljes mértékben még ma."
    }
  },
  "checkToken": {
    "invalid": {
      "title": "A link már nem érvényes.",
      "perex": "A megadott hivatkozás már nem működik. Vagy már felhasználták, vagy megváltoztak a felhasználási szabályok."
    }
  },
  "hrbRegistration": {
    "unfinishedRegistration": {
      "title": "A regisztráció befejezéséhez igazolnia kell az e-mail címét."
    }
  },
  "hrbForm": {
    "thankYou": {
      "question": {
        "button": "Új kérdés"
      },
      "prevention": {
        "content": {
          "thankYou": "Köszönjük. <br/><br/>A Soulody.hu csapata."
        }
      }
    }
  },
  "preventionForm": {
    "birthDate": {
      "title": "Születési dátum",
      "helpText": "Add meg a születési dátumot nap, hónap, év formátumban, pl. 1999.01.21.",
      "errorText": "Töltse ki a születési dátumát. ",
      "errorTextBirthDateRange": "Adja meg a helyes születési dátumát."
    },
    "gender": {
      "title": "Nem",
      "selectGender": "Válassza ki a nemet",
      "errorText": "Válassza ki a nemét.",
      "male": "Férfi",
      "female": "Nő",
      "other": "Egyéb"
    },
    "preventiveCheckUp": {
      "title": "Megelőző vizsgálatok és védőoltások",
      "selectYear": "Adja meg az évszámot"
    }
  },
  "ulekareContacts": {
    "email": "info@soulody.com"
  },
  "authorizationPage": {
    "title": "Az engedélyezés sikeres volt",
    "successText": "Sikeresen ellenőriztük,  Ön jogosult az ingyenes szolgáltatásra."
  },
  "errorModal": {
    "title": "Hoppá, ez az oldal most nem igazán tetszik.",
    "subtitle": "<p>Úgy tűnik, technikai probléma merült fel a mi oldalunkon.</p>\n\n<p><strong>Mit próbálhat meg?</strong></p>\n<ul>\n  <li>Frissítse az oldalt a Ctrl + F5 (Windows) vagy a Cmd + Shift + R (macOS) billentyűkombinációval.</li>\n  <li>Jelentkezzen ki, majd jelentkezzen be újra.</li>\n</ul>\n<br/>\n<p>Még mindig nem működik? Nyissa meg az oldalt privát (inkognitó) ablakban.</p>",
    "errorCodeReference": "Kérjük, a kommunikációban említse meg a következő hibakódot:"
  },
  "renewPassword": {
    "subtitle": "Hozzon létre új jelszót a fiókjához. Azt javasoljuk, hogy erősebb jelszót hozzon létre, amely legalább egy számot és egy betűt tartalmaz.",
    "setPassword": "Adja meg a jelszót",
    "setPasswordAgain": "Ismételje meg a jelszót",
    "minLengthError": "A jelszónak legalább 5 karakterből kell állnia.",
    "generatedError": {
      "start": "A jelszó",
      "minLength": "legalább {length} karakter hosszúságú legyen",
      "and": "és",
      "require": "tartalmazzon",
      "oneChar": "betűt",
      "oneNumber": "számot",
      "specialChar": "különleges karaktert"
    },
    "successMessage": "A jelszó sikeresen módosítva.",
    "nextButton": "Jelentkezzen be a Soulody.hu oldalra."
  },
  "emailVerification": {
    "successMessage": "E-mail megerősítve",
    "successMessagePerex": "Az e-mail-címe sikeresen megerősítve. Bejelentkezhet.",
    "button": "Folytassa a {service}"
  },
  "partnerNavigation": {
    "hello": {
      "items": [
        {
          "icon": "compass"
        },
        {
          "icon": "glasses"
        }
      ]
    },
    "helloHrb": {
      "items": [
        {
          "icon": "compass"
        },
        {
          "icon": "glasses"
        }
      ]
    },
    "partnerSignpost": {
      "title": "Van ingyenes szolgáltatása?",
      "subtitle": "Ki fizet a szolgáltatásért?"
    },
    "employer": {
      "searchPlaceholder": "Adja meg a cég nevét"
    },
    "partnerTypes": [
      {},
      {
        "buttonText": "Kiválasztás"
      },
      {},
      {
        "buttonText": "Kiválasztás"
      }
    ]
  },
  "login": {
    "socials": {
      "facebook": "Bejelentkezés Facebook-on keresztül",
      "google": "Bejelentkezés Google-val",
      "apple": "Bejelentkezés Apple alkalmazással"
    },
    "title": "Bejelentkezés",
    "subtitle": "A soulody.hu szolgáltatásainak igénybevételéhez jelentkezzen be",
    "loginError": "Lehet, hogy elírás, lehet, hogy hibás adatok. Kérjük, próbálja meg újra.",
    "forgetPassword": "Elfelejtett jelszó?",
    "password": {
      "title": "Jelszó",
      "requiredError": "A jelszó megadása kötelező"
    },
    "login": "Bejelentkezés",
    "noAccount": "Még nincs orvos a zsebében?",
    "registration": "Regisztráljon.",
    "registrationHeaderButton": "Regisztráljon"
  },
  "registration": {
    "title": "Regisztráció",
    "subtitleFirstStep": "Regisztráljon, hogy hozzáférhessen a soulody.hu szolgáltatásaihoz.",
    "emailError": "Ezt az e-mail címet már regisztrálta. Kérjük, jelentkezzen be.",
    "email": {
      "errorText": "Kérem, töltse ki az e-mail címét.",
      "title": "Személyes e-mail"
    },
    "socials": {
      "facebook": "Regisztráljon Facebook-on keresztül",
      "google": "Regisztráljon Google-val",
      "apple": "Regisztráljon Apple alkalmazással"
    },
    "loginText": {
      "link": "Jelentkezzen be",
      "suffix": ", kérjük",
      "question": "Ez az e-mail-cím már regisztrált."
    },
    "login": {
      "text": "Már van fiókja?",
      "link": "Jelentkezzen be"
    },
    "legal": {
      "text": "Hozzájárulok a {termsAndConds}.",
      "termsConditions": "felhasználási feltételek",
      "privacyPolicy": "személyes adatok védelmének alapelvei szerint történik."
    }
  },
  "missingProfileData": {
    "title": "Adatok kiegészítése",
    "titleLegal": "Hozzájárulások megerősítése",
    "text": "A csatlakoztatott fiókból nem sikerült megszereznünk az Ön e-mail-címét, amelyre szükségünk van a kapcsolattartáshoz. Kérjük, adja meg alább.",
    "textLegal": "Kérjük, erősítse meg a következőket:"
  },
  "phoneVerification": {
    "title": "Telefonszám-ellenőrzés",
    "subtitle": "Az Ön telefonszámára {phone} egy ellenőrző kódot küldtünk SMS-ben. Kérjük, írja be a kódot.",
    "label": "SMS-kód",
    "changeNumber": "Szám módosítása",
    "codeError": "A megadott kód nem érvényes. Tanácsra van szüksége?",
    "sendAgain": "A kód újraküldése",
    "verify": "Ellenőriz"
  },
  "lostPassword": {
    "title": "Elfelejtett jelszó",
    "subtitle": "A jelszó-helyreállítási linket akkor kapja meg, ha ezzel az e-mail címmel regisztrált weboldalunkon vagy mobilalkalmazásunkban.",
    "button": "Jelszó helyreállítása",
    "linkSentTitle": "Elküldve",
    "linkSentPerex": "A jelszó helyreállítására szolgáló e-mailt elküldtük a(z) {email} címre. Ha nem találja azt a beérkezett üzenetek között, kérjük, ellenőrizze a „SPAM” mappát.",
    "sendLinkAgain": "E-mail újraküldése"
  },
  "profileSection": {
    "menu": {
      "profile": "Az én fiókom",
      "logout": "Kijelentkezés"
    },
    "badge": {
      "self": "önköltséges",
      "premium": "Fizetve"
    },
    "freeService": {
      "title": "Ingyenes szolgáltatás",
      "text": "A szolgáltatás költségeit gyakori, hogy partnerek, munkáltatók vagy biztosítók állják."
    },
    "thankYou": "A szolgáltatásokat a {partnerName} téríti.",
    "thankYouSelf": "A szolgáltatásokat Ön téríti.",
    "thankYouHost": "A szolgáltatásokat a {host} téríti."
  },
  "dashboard": {
    "menu": {
      "home": "Kezdőlap",
      "questions": "Tanácsadás",
      "appointments": "Időpontfoglalás",
      "prevention": "Megelőzés",
      "explore": "Fedezze fel"
    },
    "personalInfoAssurance": {
      "email": "E-mail"
    },
    "deactivatedUser": "<strong>Fiókját deaktiváltuk.</strong> <span class=\"black--text\">Kérdés esetén vegye fel velünk a kapcsolatot: <a href=\"mailto:{email}\">{email}</a> vagy hívjon minket a következő telefonszámon: {phone}.</span>",
    "title": "Üdvözöljük Önt! 👋",
    "subtitle": "Hogyan segíthetünk Önnek?",
    "needAdvice": "Kérdés megírása",
    "needAppointment": "Időpont foglalás",
    "supportBox": {
      "openTitle": "Ügyféltámogatás",
      "title": "Ügyfélszolgálat",
      "boxText": "Itt vagyunk Önnek, ha bármilyen segítségre van szüksége",
      "chat": {
        "title": "Ügyfélszolgálati chat",
        "textOnline": "Online vagyunk <br /> Ha bármilyen nem egészségügyi kérdése vagy problémája van. Mi itt vagyunk Önnek. ",
        "textOffline": "Offline állapotban vagyunk <br /> Online vagyunk 8:00 - 17:00 (H-P)",
        "button": "Chat indítása",
        "icon": "chat"
      },
      "customerService": {
        "title": "Ügyfélszolgálati vonal",
        "buttonEmail": {
          "text": "info@soulody.com"
        },
        "buttonPhone": {
          "text": "+36 1 765 4717"
        },
        "linkEmail": "mailto: info@soulody.com",
        "linkPhone": "tel: +36 1 765 4717",
        "icon": "care",
        "tescoButtonPhonePaid": "+36 1 765 4717",
        "tescoLinkPhonePaid": "+36 1 765 4717"
      },
      "assistanceService": {
        "subtitle": "Pszichológiai tanácsadás",
        "icon": "happy"
      },
      "covidService": {
        "title": "Covid infóvonal",
        "icon": "lungs"
      },
      "unavailableOn": "Felhívjuk figyelmét, hogy {date} napon az ügyfélszolgálat és a rendeléskezelés korlátozottan lesz elérhető. A beérkező megkeresések feldolgozása késedelmet szenvedhet. Általános információkért kérjük, írjon nekünk a megadott e-mail címre. \nKöszönjük megértését.",
      "outageActive": "false",
      "outageDateISO": "2026-04-09"
    },
    "requestSent": "Fejezze be az aktiválást a munkahelyi e-mail fiókjában.",
    "questions": {
      "myQuestions": "Kérdéseim",
      "updated": "Megvan a válasz az Ön számára!"
    },
    "appointments": {
      "myAppointments": "A rendelésem"
    },
    "videoCall": {
      "buttonText": "Videóhívás ütemezése",
      "buttonTextMobile": "Videóhívás"
    },
    "services": {
      "question": {
        "title": "Tanácsadás (24/7)",
        "subtitle": "{hours} órán belüli válasz",
        "text": "Általános orvosok és szakorvosok egy helyen. Önnek, éjjel-nappal."
      },
      "videoCall": {
        "title": "Videóhívás",
        "subtitle": "egy orvossal",
        "text": "Az orvosok 20 percig foglalkoznak Önnel a videóhívás alatt, az Ön által választott időpontban.",
        "button": "Videóhívás ütemezése"
      },
      "appointment": {
        "title": "Időpontfoglalás",
        "subtitle": "Magyarország egész területén",
        "text": "A nővérek segítenek megtalálni azt az orvost, amelyre szüksége van.",
        "button": "Időpontot szeretnék foglalni"
      },
      "prevention": {
        "title": "Megelőzés",
        "subtitle": "egészség az Ön kezében",
        "text": "Az egészség a Öné. Mi pedig szívesen segítünk Önnek gondoskodni róla."
      },
      "labTest": {
        "subtitle": "Egészség az Ön kezében"
      }
    },
    "news": "Újdonságok",
    "emailVerification": {
      "title": "E-mail cím ellenőrzése",
      "subtitle": "Lépjen be <strong>{email}</strong> e-mail fiókjába, és kattintson az e-mailben küldött megerősítő hivatkozásra.",
      "text": [
        {
          "title": "Nem kapta meg az e-mailt?",
          "list": [
            {
              "icon": "check_circle",
              "text": "Előfordulhat, hogy a levél a promóciók vagy a kéretlen üzenetek (spam) mappájában található."
            },
            {
              "icon": "check_circle",
              "text": "Ez eltarthat néhány percig. Még mindig semmi? Próbálja meg újraküldeni az e-mailt."
            }
          ]
        },
        {
          "title": "Nem megfelelő e-mail-címet adott meg?",
          "text": "Nem gond. Regisztráljon újra."
        }
      ],
      "actions": {
        "right": {
          "baseText": "E-mail újraküldése"
        }
      }
    },
    "help": {
      "text": "Nem tudja, mit tegyen?"
    }
  },
  "videoCall": {
    "infoStep": {
      "title": "Videóhívás egy orvossal",
      "perex": "Kérjen időpontot egy videóhívásra, és beszéljen meg bármilyen egészségügyi problémát orvosával, anélkül, hogy elmenne az orvosi rendelőbe.",
      "list": {
        "first": "Győződjön meg róla, hogy kitöltötte az alapvető adatait, és rendelkezik egy ellenőrzött telefonszámmal.",
        "second": "Válasszon egy Önnek megfelelő időpontot. Akár az ebédszünetben is telefonálhat.",
        "third": "Ön a megbeszélt időpontban csatlakozik a videóhíváshoz. Az orvos 20 percet csak Önnek szentel."
      },
      "legal": [
        "A szolgáltatást egy egészségügyi szolgáltató, az alábbi vállalat szolgáltatja:",
        "uLékaře.cz Health Care, s.r.o.<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;székhelye: Českomoravská 1a, 190 00 Prága 9 ID-szám: 096 64 777<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;a prágai városi bíróságon C 339989 számon bejegyezve",
        "Az orvossal folytatott videohívást az állami egészségbiztosítás nem fedezi. A költségeket a munkáltatója fedezi."
      ],
      "button": "Válassza ki a videóhívás időpontját."
    },
    "formStep": {
      "title": "Ellenőrizze az adatokat.",
      "legal": {
        "termsConditions": {
          "text": "Elfogadom a {legalText}  uLékaře.cz Health Care, s.r.o. egészségügyi szolgáltató orvosával folytatott videohíváshoz.",
          "legalText": "Szolgáltatási feltételek"
        },
        "personalData": {
          "text": "A személyes adatok kezelése a",
          "legalText": "Adatvédelmi irányelvek"
        }
      }
    }
  },
  "tally": {
    "anxiety": {
      "dashboardBox": {
        "title": "Szorongási szint teszt",
        "text": "A kérdőív megmutatja, hogy áll a szorongással."
      },
      "infoStep": {
        "title": "Milyen tapasztalata van a szorongással?",
        "timeApproximation": "2 perc",
        "perex": "A szorongás a félelem, a rossz előérzetek és az aggodalom kombinációja.  Ez egy kellemetlen fenyegetettség- és feszültségérzet, amely különböző intenzitású lehet. Hasonlíthat a stresszre.",
        "list": [
          "Töltse ki a rövid kérdőívet, hogy megtudja, mennyire valószínű Önnél a szorongás kockázata.",
          "Azonnali tanácsokkal látjuk el, vagy egy segítő kezet nyújtunk Önnek."
        ],
        "garant": {
          "title": "A teszt felelőse",
          "name": "Mgr. Štěpánová Michaela",
          "specialization": "Pszichológia Mester (Pszichológia MA)",
          "workplace": "A Soulody.hu pszichológusa"
        },
        "button": "Kérdőív kitöltése"
      },
      "urls": {
        "b2b": "https://tally.so/r/3EBJal"
      }
    },
    "nicotine": {
      "dashboardBox": {
        "title": "Nikotinfüggőség",
        "text": "Néhány kérdésből kiderül, hogy valóban nikotinfüggő-e."
      },
      "infoStep": {
        "title": "Nikotinfüggő?",
        "timeApproximation": "2 perc",
        "perex": "A nikotin fogyasztása nem csupán egy rossz szokás - komolyan veszélyeztetheti az egészségét. Végezze el a tesztet,, ha dohányzik, e-cigarettázik, iQOS-t használ vagy esetleg VELO-t fogyaszt, stb.",
        "list": [
          "Válaszoljon 6 nikotinnal kapcsolatos kérdésre.",
          "Tudja meg, hogy függőségtől szenved-e."
        ],
        "garant": {
          "title": "A kérdőív kitöltése",
          "name": "MUDr. Dvouletá Lenka",
          "specialization": "Pneumatológia és ftizeológia doktor",
          "workplace": "a Tomáš Baťa Kórházban Zlínben (Csehország)"
        },
        "button": "A kérdőív kitöltése"
      },
      "urls": {
        "b2b": "https://tally.so/r/mRbWKP"
      }
    },
    "wellbeing": {
      "dashboardBox": {
        "title": "Jóllét teszt",
        "text": "Hogy érzi magát valójában? Végezze el a jó közérzet tesztet."
      },
      "infoStep": {
        "title": "Jól érzi magát?",
        "timeApproximation": "~2 perc",
        "perex": "A „wellbeing” kifejezés, avagy a jóllét, a testi, a lelki és az érzelmi egészség teljeskörű állapotát jelenti. A jóllétet befolyásolhatja, egyéb tényezők mellet, az egészségi állapot és a különböző kapcsolatok kialakítása is.",
        "list": [
          "Válaszoljon 5 rövid kérdésre.",
          "Az eredményét azonnal megosztjuk Önnel, olyan tippekkel ellátva, amelyek segítenek Önnek jobban érezni magát."
        ],
        "garant": {
          "title": "A tesztért felelős",
          "name": "Mgr. Štěpánová Michaela",
          "specialization": "Pszichológia Mester (Pszichológia MA)",
          "workplace": "A Soulody.hu pszichológusa"
        },
        "button": "A kérdőív kitöltése"
      },
      "urls": {
        "b2b": "https://tally.so/r/wgJbjK"
      }
    },
    "insomnia": {
      "dashboardBox": {
        "title": "Alvászavar teszt",
        "text": "Hogy áll az alvásod? Töltsd ki a tesztünket."
      },
      "infoStep": {
        "title": "Hogy alszol?",
        "timeApproximation": "~2 perc",
        "perex": "Az utóbbi időben nehezen tud elaludni? Vagy az éjszaka közepette fel szokott ébredni? A tartós alvászavar hatással lehet az életminőségére és az egészségére.",
        "list": [
          "Válaszoljon 2 perc alatt nyolc rövid kérdésre.",
          "Az eredményét azonnal megosztjuk Önnel, gyakorlati ajánlásokkal együtt."
        ],
        "garant": {
          "title": "A teszt felelőse",
          "name": "Mgr. Štěpánová Michaela",
          "specialization": "Pszichológia Mester (Pszichológia MA)",
          "workplace": "A Soulody.hu pszichológusa"
        },
        "button": "Kérdőív kitöltése"
      },
      "urls": {
        "b2b": "https://tally.so/r/3EBBZN"
      }
    },
    "depression": {
      "dashboardBox": {
        "title": "Depressziókockázati teszt",
        "text": "Rossz hangulat vagy depresszió? Tesztelje magát.",
        "button": "Kérdőív kitöltése"
      },
      "infoStep": {
        "title": "Rossz hangulat vagy depresszió?",
        "timeApproximation": "~2 perc",
        "perex": "Mostanában kimerültnek, energiátlannak, örömtelennek érzi magát? Az online depressziókockázati teszt segíthet feltérképezni az érzéseit.",
        "list": [
          "Válassza ki az Ön esetére leginkább érvényes válaszokat.",
          "Azonnali kiértékelés praktikus tanácsokkal."
        ],
        "garant": {
          "title": "A tesztért felelős",
          "name": "Mgr. Štěpánová Michaela",
          "specialization": "Pszichológia",
          "workplace": "A Soulody.hu pszichológusa"
        },
        "button": "Kérdőív kitöltése"
      },
      "urls": {
        "b2b": "https://tally.so/r/mDZo0p"
      }
    },
    "liver": {
      "dashboardBox": {
        "title": "Teszt az egészséges májért",
        "text": "Tesztelje le magát, mennyire jól gondoskodik a májáról.",
        "button": "Kitöltöm a tesztet"
      },
      "infoStep": {
        "title": "Megfelelően gondoskodik a májáról?",
        "timeApproximation": "~3 perc",
        "perex": "Ez a rövid vizsgálat megmutatja, hogy milyen állapotban van a mája, és hogy több törődést igényel-e, mint ezidáig.",
        "list": [
          "Válassza ki azokat a kijelentéseket, amelyek Ön szerint helyesek és az egészségügyi állapotát tükrözik.",
          "Azonnali kiértékelés praktikus tanácsokkal."
        ],
        "garant": {
          "title": "Felelős személy",
          "name": "Mjr. MUDr. Gottvaldová Denisa, Soulody.hu",
          "specialization": "Felnőtt háziorvos",
          "workplace": "Bechyně Egészségügyi Központ"
        },
        "button": "Kitöltöm a tesztet"
      },
      "urls": {
        "b2b": "https://tally.so/r/w5M7EN"
      }
    },
    "heart": {
      "dashboardBox": {
        "title": "Egészséges a szíve?",
        "text": "Néhány kérdésből kiderül, mire van szüksége a szívének.",
        "button": "Kitöltöm a tesztet"
      },
      "infoStep": {
        "title": "Hogy van a szíve?",
        "timeApproximation": "~3 perc",
        "perex": "Ez a vizsgálat felfedi, hogy a szíve jó egészségnek örvend, vagy riadót fúj.",
        "list": [
          "Válaszoljon tíz rövid kérdésre 3 perc alatt.",
          "Azonnali kiértékelés praktikus tippekkel."
        ],
        "garant": {
          "title": "A tesztért felelős",
          "name": "Dr. Oleksii Bolotskykh",
          "specialization": "Felnőtt kardiológia",
          "workplace": "Kardiologie na Bulovce, s.r.o."
        },
        "button": "Kitöltöm a tesztet"
      },
      "urls": {
        "b2b": "https://tally.so/r/mZW84y"
      }
    },
    "movement": {
      "urls": {
        "b2b": "https://tally.so/r/mVyPka"
      },
      "infoStep": {
        "button": "Kitöltöm a tesztet",
        "garant": {
          "workplace": "YOTAI, Prágai Nemzeti Színház magánrendelő",
          "specialization": "Fasciális szakorvos, tánc- és sportorvosi szakértő",
          "name": "MgA. Klára Lidová, Ph.D.",
          "title": "A tesztért felelős"
        },
        "list": [
          "Válaszoljon tíz rövid kérdésre 2 perc alatt.",
          "Azonnali kiértékelés praktikus tippekkel."
        ],
        "perex": "Egy gyors tesztből kiderül, hogy elegendő testmozgást végez-e vagy a teste cselekvésre ösztönzi.",
        "timeApproximation": "~2 perc",
        "title": "Eleget mozog?"
      },
      "dashboardBox": {
        "button": "Töltse ki a tesztet",
        "text": "Tesztelje le az alkalmasságát egy rövid online teszttel.",
        "title": "Ön és a mozgás"
      }
    }
  },
  "profileAuthorization": {
    "language": {
      "title": "Szolgáltatásbeállítások",
      "text": "Válassza ki, hogy milyen nyelven szeretné használni a szolgáltatást.",
      "errorText": "A szolgáltatója nem támogatja ezt a nyelvet, kérjük, válasszon egy másikat."
    },
    "final": {
      "title": "Köszönjük a regisztrációt!",
      "text": "Ezentúl a zsebében találja a Soulody.hu szolgáltatást! Orvosaink és nővéreink szívesen állnak a rendelkezésére."
    },
    "possiblePartners": {
      "title": "Jó hírünk van! Valószínűleg jogosult az ingyenes szolgáltatásra.",
      "textHrb": "Erősítse meg, hogy ki fizeti a szolgáltatást, és ki segít Önnek az egészséghez vezető úton. Nem tud választani? Tekintse meg partnereink listáját.",
      "changePartner": "Válasszon a listáról"
    },
    "hrbPartner": {
      "title": "Indítsa el az ingyenes szolgáltatást",
      "textBoth": "Adja meg a céges e-mail címét vagy a {partner}-től/-tól kapott kódszámot.",
      "textEmail": "Adja meg a munkahelyi e-mail címét.",
      "textCode": "Adja meg az aktiváló kódot, amelyet a(z) {partner} partnertől kapott.",
      "tabs": [
        "E-maillel",
        "Kódszámmal"
      ],
      "email": "Céges e-mail-cím",
      "code": "Aktiváló kód",
      "codeError": "<strong>Sajnos ez a kód érvénytelen.</strong><br>Kérjük, ellenőrizze a kód helyességét a HR-osztályával.<br>Ha a kód helyes, ügyfélszolgálatunk",
      "emailError": "Érvénytelen e-mail. Tudja, mit kell tennie? Írjon nekünk a következő címre <a href=\"mailto:info@soulody.com\">info@soulody.com</a>.",
      "invalidEmployeeEmail": "A munkáltató vagy a partner nem engedélyezte az ingyenes szolgáltatáshoz való hozzáférést ennél az e-mail címnél.",
      "benefitBlocked": "Ez az e-mail-cím már egy másik munkáltatóhoz/partnerhez van társítva, ezért itt nem tudja ingyenesen aktiválni a szolgáltatást.",
      "clientSupport": "szívesen segít Önnek.",
      "startTitle": "Indítsa el az ingyenes szolgáltatást",
      "formTitle": "Adja meg a vállalat e-mail-címét vagy kódját",
      "startUsing": "Adja meg a vállalat e-mail-címét vagy kódját",
      "formDescription": "Kérjük, töltse ki az alábbi adatokat az ingyenes szolgáltatásra való jogosultság ellenőrzéséhez.",
      "description": {
        "code": "Aktiválási kód",
        "email": "Aktiváló e-mail"
      }
    },
    "emailAuthorization": {
      "title": "Köszönjük, hogy érdeklődik az ingyenes szolgáltatás aktiválása iránt!",
      "subtitle": "Küldtünk egy aktiváló e-mailt a következő e-mail címre: <strong class=\"black--text\">{email}</strong>. Kattintson az e-mailben található linkre az ingyenes szolgáltatás aktiválásához.",
      "text": [
        {
          "title": "Nem kapta meg az e-mailt?",
          "list": [
            {
              "text": "Nézze meg a spam vagy tömeges levelek mappában."
            },
            {
              "text": "Időre lehet szükség, mire megérkezik.",
              "text ": "Időre lehet szükség, mire megérkezik."
            }
          ]
        },
        {
          "title": "Rossz e-mail címet adott meg?",
          "link": {
            "textBefore": "Módosítsa",
            "text": "itt"
          }
        }
      ],
      "actions": {
        "left": {
          "baseText": "E-mail újraküldés"
        }
      }
    },
    "authorizationSignpost": {
      "title": "Ki fizet a szolgáltatásért?",
      "text": "Használja a Soulody.hu szolgáltatást ingyen! Ezt a munkáltatója vagy valamelyik partnerünk (biztosítótársaságok, kártyatársaságok stb.) fizetheti.",
      "employees": "Munkáltató",
      "search": "Munkáltató keresése név szerint",
      "searchEmpty": {
        "title": "A “{text}” e-mail cím alatt nincs találatunk.",
        "text": "Szeretné, hogy szerepeljen a listánkon? Ajánlhatja nekünk."
      },
      "selfPay": "Önköltséges ügyfél"
    },
    "selfPay": {
      "title": "Önköltséges ügyfél",
      "text": "Elintézzük Önnek:",
      "priceSufix": "/kérdés",
      "list": [
        {
          "icon": "doctor",
          "text": "8 órán belüli kapcsolat orvossal"
        },
        {
          "icon": "shield",
          "text": "Megelőző program közvetlenül Önre szabva"
        },
        {
          "icon": "news",
          "text": "Gyakorlatias orvosi egészségtippek"
        }
      ]
    },
    "chooseDifferentCompany": "Másik vállalat kiválasztása"
  },
  "profile": {
    "title": "Az én fiókom",
    "titleMobile": "Beállítások",
    "subtitle": "Kezelje adatait.",
    "basicData": "Alapvető adatok",
    "emailNote": "Az e-mail cím megváltoztatása nem lehetséges.",
    "phoneNote": "A nővéreink ezen a telefonszámon tudnak kapcsolatba lépni Önnel, hogy segítsenek a kérelmei megoldásában.",
    "security": "Biztonság",
    "currentPassword": "Eredeti jelszó",
    "newPassword": "Új jelszó",
    "additionalInfo": "További adatok",
    "birthDateNote": "Az életkor megadása segít a pontosabb orvosi vélemény írásában.",
    "address": "Cím",
    "addressNote": "Az Ön címe alapján keresünk Önnek megfelelő orvost.",
    "family": "Az én családom",
    "aboutApp": "Az alkalmazásról",
    "moreOptions": "Egyéb lehetőségek",
    "healthInsuranceProvider": {
      "title": "Egészségbiztosító társaság",
      "note": "Olyan orvost keresünk, aki együttműködik az Ön egészségbiztosítójával."
    },
    "applicationLanguage": {
      "title": "Az alkalmazás nyelve",
      "message": "Ezen a nyelven jelenik meg a weboldal."
    },
    "serviceLanguage": {
      "title": "A szolgáltatás nyelve",
      "message": "Orvosa ezen a nyelven fog válaszolni"
    },
    "changeLanguageNotification": {
      "text": "A változtatások mentése után a webhely nyelve a következőre változik"
    },
    "removeSection": {
      "title": "Fiók törlése",
      "text": "Fiókja deaktiválódik. Ha meggondolja magát, a deaktiválást a fiókjába való bejelentkezéssel visszavonhatja. 30 nap elteltével nem tud visszatérni fiókjába.",
      "button": "Fiók törlése"
    },
    "removeDialog": {
      "title": "Biztos vagy benne?",
      "areYouSure": {
        "text": "Fiókja deaktiválódik. Ha meggondolja magát, a deaktiválást a fiókjába való bejelentkezéssel visszavonhatja. 30 nap elteltével nem tud visszatérni fiókjába.",
        "yes": "Fiók törlése",
        "no": "Egészséges maradok",
        "title": "Biztosan törölni szeretné a fiókját?"
      },
      "list": [
        {
          "icon": "chat-empty",
          "text": "Elveszíti a prevenciós útmutatóját, így nehezebb lesz az egészségéről gondoskodnia."
        },
        {
          "icon": "surgeon",
          "text": "A Soulody.hu több mint 350 orvosától és ápolójától kell elbúcsúznia, akik segíthetnek Önnek."
        },
        {
          "icon": "person-sad",
          "text": "Elveszíti az orvosoktól kapott értékes válaszokat és az egészségével kapcsolatos áttekintést."
        }
      ],
      "footer": "Kérdése van vagy segítségre van szüksége? Ügyfélszolgálatunk elérhető az {email} címen vagy {phone}.",
      "cancelButton": "Egészséges maradok",
      "deleteButton": "Fiók törlése",
      "confirmTitle": "A fiókod törlésre kerül.",
      "confirmText": "Ha meggondolja magát, a következő 30 napon belül visszaállíthatja fiókját, ha bejelentkezik jelenlegi bejelentkezési adataival. <br/>Ha bármilyen kérdése van, kérjük, vegye fel a kapcsolatot ügyfélszolgálatunkkal a következő címen: <a href=\"mailto: info@soulody.com\">info@soulody.com</a> vagy <a href=\"tel:003617654717\">+36 1 765 4717</a>.",
      "feedback": {
        "title": "Miért távozik?",
        "checkboxes": {
          "no_or_low_use": "Már nincs szükségem a szolgáltatásra, vagy ritkán használom",
          "disappointed": "A szolgáltatás nem felelt meg az elvárásaimnak",
          "technical_issues": "Technikai problémák a rendszerrel",
          "price_too_high": "Számomra túl magas az ár",
          "better_alternative": "Más szolgáltatást használok",
          "other": "Egyéb ok / nem szeretném megadni"
        },
        "detailsLabel": "Mondjon el többet",
        "confirm": "Fiók törlése",
        "cancel": "Egészséges maradok"
      }
    },
    "benefits": {
      "consultation_forum": {
        "chip": "Tanácsadás"
      },
      "booking": {
        "chip": "Időpontfoglalás"
      },
      "prevention_plan": {
        "chip": "Megelőzés"
      },
      "insurance_contributions": {
        "chip": "Egészségpénztári támogatások",
        "tooltip": "Tudja meg, milyen ellátásokra jogosult az egészségpénztárnál."
      },
      "health_tests": {
        "chip": "Egészségtesztek",
        "tooltip": "Töltsön ki egy rövid tesztet, hogy többet megtudjon az egészségéről."
      },
      "video_call_therapist": {
        "chip": "Videohívás: terapeuta",
        "tooltip": "Foglaljon időpontot online ülésre terapeutával."
      },
      "content_explore": {
        "chip": "Fedezze fel"
      },
      "helpline_free": {
        "chip": "Ingyenesen hívható vonal",
        "tooltip": "Hétköznapokon 8:00 és 17:00 óra között állunk rendelkezésére."
      },
      "video_call_doctor": {
        "chip": "Videóhívás: orvos",
        "tooltip": "Foglaljon időpontot videohívásra orvossal."
      },
      "assistance_line": {
        "chip": "Segélyvonal"
      },
      "blood_tests_review": {
        "chip": "Vérvizsgálatok + magyarázat"
      }
    },
    "benefit": {
      "validTo": "Érvényes",
      "availableServices": "Elérhető az Ön számára",
      "title": "Szolgáltatáskezelés",
      "subtitle": "Az Ön ingyenes szolgáltatásainak jelenlegi beállításai",
      "card": {
        "authorize": "Aktív",
        "prolong": "Az érvényesség hamarosan lejár",
        "pending": "Várakozás a szolgáltatás aktiválásának befejezésére",
        "ended": "Az érvényesség lejárt",
        "family": "Aktív (családtag)",
        "familyExpired": "Kérje meg szeretteit egy ingyenes szolgáltatásbővítésre"
      },
      "partnerSuggestions": {
        "title": "Ingyenes szolgáltatóváltás",
        "subtitle": "Az ingyenes szolgáltatását csak egy cég vagy partner fizetheti.",
        "nosearch": {
          "title": "Nincs kedve keresgélni? Semmi gond.",
          "subtitle": "Lehet, hogy a 6 partnerünk egyikének köszönhetően ingyenesen veheti igénybe a szolgáltatást."
        }
      },
      "searchPlaceholder": "Adja meg a cég vagy a partner nevét",
      "selectPartner": "Az ingyenes szolgáltatás aktiválása",
      "serviceNotActive": "Az ingyenes szolgáltatás nem aktív",
      "b2c": {
        "title": "Önnek nincs kijelölt cége vagy partnere, aki fizet a szolgáltatásért.",
        "subtitle": "Adja meg az adott cég vagy partner nevét, hogy ingyenes hozzáférést kapjon a szolgáltatáshoz."
      },
      "authorization": {
        "none": "Aktiválás másképp",
        "email": "Aktiválás e-maillel",
        "codeOnly": "Aktiválás kóddal",
        "codeAndEmail": "Aktiválás kóddal és e-maillel",
        "code": {
          "finished": {
            "buttonText": "Kész"
          }
        }
      },
      "prolong": {
        "buttonText": "Bővítse szolgáltatását ingyenesen"
      },
      "authorize": {
        "buttonText": "Aktiválja szolgáltatását ingyenesen"
      },
      "goback": "Vissza",
      "partnerDetected": {
        "title": "Valószínűleg Ön jogosult az ingyenes szolgáltatásra. Érvényes?",
        "subtitle": "Ha igen, aktiválja az ingyenes szolgáltatást."
      },
      "family": {
        "buttonText": "Jelenlegi beállítások"
      },
      "ended": {
        "buttonText": "Bővítse szolgáltatását ingyenesen"
      },
      "info": {
        "ended": "Aktiválja újra az ingyenes szolgáltatást",
        "authorize": "Az ingyenes szolgáltatás aktív",
        "prolong": "Az ingyenes szolgáltatás érvényessége hamarosan lejár",
        "family": "Az ingyenes szolgáltatás családi megosztásnak köszönhetően aktív"
      },
      "manage": {
        "buttonText": "Szolgáltatás-beállítás kezelése"
      },
      "reauthorize": {
        "buttonText": "Hosszabbítsa meg előfizetését ingyenesen"
      },
      "showMore": "Továbbiak megjelenítése",
      "showLess": "Rövidebben"
    },
    "multifactor": {
      "label": "Kétlépcsős azonosítás",
      "off": "Kikapcsolva",
      "offInfo": "Kétlépcsős azonosítás kikapcsolva",
      "sms": "SMS ellenőrzés",
      "smsInfo": "Bejelentkezéskor a telefonjára ellenőrző kódot küldünk.",
      "email": "E-mailes ellenőrzés",
      "emailInfo": "Bejelentkezéskor ellenőrző kódot küldünk az e-mail-címére."
    }
  },
  "passwordRenewal": {
    "title": "Frissítse jelszavát.",
    "subtitle": "Frissítenie kell a jelszavát, mert lejárt.",
    "currentPassword": "Jelenlegi jelszó:",
    "newPassword": "Új jelszó:",
    "passwordRules": "A jelszó legalább 12 karakter hosszúságú legyen, tartalmazzon 1 betűt, 1 számot, 1 különleges karaktert (-=%*+./![]@#$^&()?;).",
    "confirmation": "Erősítse meg új jelszavát",
    "passwordsDontMatch": "A jelszavak nem egyeznek",
    "thankYouTitle": "A jelszó sikeresen módosítva.",
    "thankYouSubtitle": "A jelszó sikeresen módosítva."
  },
  "questions": {
    "answerDisclaimer": "Felhívjuk figyelmét, hogy a fenti válasz csak tájékoztató jellegű.&nbsp;&nbsp;Általános tanácsokat és információkat tartalmaz az egészség, a betegség vagy más egészségügyi problémák területén.&nbsp;A fenti információk nem tekinthetők egyéni diagnózis, kezelési terv vagy megelőzési terv meghatározásának, különös tekintettel az online kommunikáció korlátozott lehetőségeire.&nbsp;&nbsp;&nbsp;Mivel a felhasználói információk nem feltétlenül teljes körűek, és a fizikai vizsgálat nem lehetséges, az egyes orvosok válaszai a tapasztalataiktól és a klinikai gyakorlatuktól függően némely részletekben eltérhetnek.&nbsp;A szolgáltatás használata semmiképpen sem helyettesíti az orvos általi személyes vizsgálatot. Egészségügyi problémák esetén javasoljuk, hogy a probléma jellegétől függően forduljon orvoshoz vagy más szakemberhez. Előfordulhat, hogy az orvos válaszát fordító segítségével fordították le, ami után azt mindig alaposan ellenőrzi egy egészségügyi szakember.",
    "title": "Tanácsadás",
    "subtitle": "Kérdezze orvosainkat, éjjel-nappal válaszolnak.",
    "noQuestion": {
      "title": "Még mindig várjuk az első kérdését.",
      "subtitle": "Miben segíthetünk Önnek?",
      "infoList": [
        {
          "text": "Azonnal tanácsot adunk Önnek, hogy a hirtelen fellépő egészségügyi problémát önállóan kezelheti-e, vagy orvosi segítségre van szükség.",
          "icon": "suitcase"
        },
        {
          "text": "A tanácsadó orvos a megfelelő vizsgálathoz vagy szakemberhez irányítja Önt.",
          "icon": "surgeon-question"
        },
        {
          "text": "Nem érti az orvosi jelentést vagy a laboreredményeket? Szakértőink szívesen elmagyarázzák.",
          "icon": "stop"
        },
        {
          "text": "Szégyenérzet nélkül, online. Az orvosok szívesen segítenek Önnek és szeretteinek egészségügyi problémákkal kapcsolatban.",
          "icon": "temperature"
        }
      ]
    },
    "newQuestion": "Új kérdés",
    "newSolved": "Olvasd el a választ",
    "waitingForAnswer": "Válaszra várva",
    "history": "Válaszolt kérdések",
    "detail": {
      "title": "A kérdés részletei",
      "sent": "Elküldött kérdés",
      "questionFormTitle": "Egészségügyi probléma leírása",
      "attachments": "Mellékletek",
      "helped": "Segített a válasz?"
    },
    "evaluation": {
      "title": "Köszönjük válaszát",
      "text": "Ön segít nekünk szolgáltatásaink javításában. Szeretne még valamit elmondani nekünk?",
      "label": "További megjegyzések és észrevételek",
      "placeholder": "Hogyan javíthatjuk a szolgáltatást?",
      "ok": "A válasz segített",
      "nok": "A válasz nem segített"
    },
    "thankYou": {
      "title": "Köszönjük, hogy elküldte kérdését.",
      "text": "A háziorvos jelenleg az Ön kérdésével foglalkozik. Amint válaszol, e-mailben értesítjük Önt."
    },
    "status": {
      "waitingGpAnswer": "Az Ön kérdése a háziorvos válaszára vár.",
      "waitingSpecialistAnswer": "Az Ön kérdése a szakorvos válaszára vár.",
      "answered": "Az orvos válaszolt a kérdésére.",
      "declined": "A kérését kénytelenek voltunk elutasítani."
    },
    "askedQuestions": "Feltett kérdések"
  },
  "appointments": {
    "title": "Időpontfoglalásaim",
    "subtitle": "Nővéreink szívesen segítenek Önnek megfelelő orvost/szakorvost találni, vagy kapcsolatba lépni jelenlegi orvosával.",
    "statuses": {
      "newDoctor": "Megtaláltuk az orvost!"
    },
    "noAppointments": {
      "title": "Még nem próbálta az időpontfoglalást a Soulody.hu oldalon keresztül.",
      "subtitle": "Hogyan működik az időpontfoglalás a Soulody.hu oldalon keresztül?",
      "infoList": [
        {
          "text": "Segítünk az időpontfoglalásban egész Magyarország területén.",
          "icon": "hospital"
        },
        {
          "text": "A nővér a következő munkanapon felveszi Önnel a kapcsolatot, és mindent elintéz, hogy mihamarabb a megfelelő orvoshoz kerüljön.",
          "icon": "nurse"
        },
        {
          "text": "Az orvoskeresést és rendelőhívogatást bízza ránk.",
          "icon": "clock"
        }
      ]
    },
    "newAppointment": "Új időpontfoglalás",
    "activeAppointments": "Intézzük",
    "visitAppointments": "Ne felejtsen el orvoshoz menni",
    "evaluateAppointments": "Értékelje az orvosnál tett látogatását",
    "history": "Befejezett időpontfoglalások",
    "detail": {
      "title": "Időpontfoglalás részletei",
      "sent": "Elküldve",
      "date": "A lefoglalt időpont:",
      "visitAt": "Mikor kell megjelennie: ",
      "facility": "Egészségügyi intézmény: ",
      "address": "Cím:",
      "doctor": "Orvos:",
      "phone": "Telefonszám: ",
      "note": "Megjegyzés:",
      "dateMandatory": "A fenti időpont kötelező érvényű!",
      "unableToVisitInfo": "Ha nem tud részt venni a megbeszélt orvosi látogatáson, kérjük, hívja a(z) {phone} telefonszámot vagy küldjön e-mailt a(z) <a href=\"mailto:{email}\">{email}</a> e-mail címre.",
      "thankYou": "Hisszük, hogy az általunk ajánlott orvos segít megoldani az egészségügyi problémáit. Kérjük, jelezze nekünk, hogy minden rendben ment-e. Köszönjük!",
      "cancelAppointment": "A rendelés törlése",
      "noVisit": "Nem volt"
    },
    "thankYou": {
      "title": "Köszönjük a foglalást!",
      "subtitle": "Kérjük, várjon.",
      "cs": "cseh",
      "en": "angol",
      "sk": "szlovák",
      "text": "Ápolónőnk a következő munkanapon visszahívja Önt a +36 1 765 4717 as telefonszámon.",
      "others": {
        "text": "Az ápoló a következő információkat fogja kérni a rendelésben érintett személyről:",
        "items": [
          {
            "icon": "register",
            "text": "Egészségbiztosító társaság"
          },
          {
            "icon": "person-happy",
            "text": "jelenlegi egészségi állapot"
          },
          {
            "icon": "news",
            "text": "teljesített vizsgák és jelentkezések"
          },
          {
            "icon": "clock",
            "text": "időbeli elérhetőség"
          }
        ]
      }
    },
    "status": {
      "waiting": "A nővér hamarosan foglalkozni fog az időpontfoglalásával, nemsokára jelentkezik.",
      "orderedForTime": "Önnek megbeszélt időpontja van ekkor: {időpont}",
      "orderedForOpeningHours": "Rendben! A rendelőben rendelési idő szerint fogadják.",
      "done": "Lezárva"
    },
    "previousAppointments": "Rendelési előzmények"
  },
  "prevention": {
    "subtitle": "Csak néhány személyes adatra van szükségünk, és elkészítjük az Ön testreszabott megelőzési tervét. Így sokkal könnyebb lesz megelőznie az egészségügyi problémákat.",
    "birthDateNote": "Az életkor csak egy szám, de tudnunk kell, hogy a megfelelő ellátást biztosíthassunk Önnek.",
    "personalization": {
      "banner": {
        "title": "Személyre szabott megelőzés",
        "subtitle": "Adjon meg néhány adatot magáról, és&nbsp;azonnal személyre szabjuk a megelőzést.",
        "button": "A személyre szabott megelőzési program megszerzése"
      },
      "title": "Az Ön életkorának megfelelő megelőző kivizsgálásai",
      "text": "Ha kikapcsolja, olyan megelőző kivizsgálásokat is látni fog, amelyeket általában idősebb korban végeznek el."
    },
    "summary": {
      "title": "Megelőzés",
      "subtitleDesktop": "Segítünk Önnek, hogy egy lépéssel a betegségek előtt járjon.",
      "showAll": "Mindent megmutatni",
      "intervalEnds": "Foglaljon időpontot mihamarabb",
      "planned": "Tervezett",
      "timeline": {
        "title": "Következő",
        "tooltip": "Itt láthatja a legközelebbi szűrővizsgálatokat és védőoltásokat - van már időpontja?"
      },
      "examinations": {
        "title": "Megelőző vizsgálatok",
        "tooltip": "Itt megtalálja a túrák időpontjait és minden információt arról, hogy mire számíthat."
      },
      "vaccinations": {
        "title": "Oltások",
        "tooltip": "Itt megtalálja az oltások időpontját és minden információt arról, hogy mire számíthat."
      },
      "tallyTests": {
        "title": "Tematikus egészségügyi tesztek"
      }
    },
    "list": {
      "examinations": {
        "recommended": "Szűrővizsgálat",
        "optional": "Szűrővizsgálat"
      },
      "vaccinations": {
        "recommended": "Kötelező védőoltások",
        "optional": "Önkéntes védőoltások"
      }
    }
  },
  "labTests": {
    "rowTitle": "Egészségtesztek"
  },
  "loginBanner": {
    "title": "Az egészség felé vezető úton az Ön útmutatója vagyunk.",
    "infoList": [
      {
        "icon": "doctor",
        "text": "Háziorvosok és szakorvosok válaszolnak a kérdésekre."
      },
      {
        "icon": "nurse",
        "text": "A nővérek segítenek az orvosi időpontfoglalásokban."
      },
      {
        "icon": "shield",
        "text": "A biztonságos online fiók teljesen az Ön kezében van."
      }
    ],
    "show": "Hogyan működik a szolgáltatás?",
    "hide": "Bezárás"
  },
  "cookiesConsent": {
    "acceptAll": "Összes elfogadása",
    "basic": {
      "title": "Weboldalunk úgy működik, mint egy orvos",
      "perex": "Weboldalunk sütiket használ, és úgy működik, mint egy orvos, aki kérdéseket tesz fel, hogy a lehető legjobban segíthessen Önnek. Ezáltal műszaki, elemzési és kereskedelmi információkat gyűjtünk, hogy folyamatosan fejlődhessünk, és még jobban segíthessünk Önnek. Elfogadja?",
      "technical": "",
      "customize": "Beállítások"
    },
    "settings": {
      "title": "Süti-beállítások",
      "description": "Amikor meglátogatja www.soulody.hu weboldalunkat, a weboldal információt gyűjt vagy tárol a böngészőjében, általában sütik formájában. Ez magában foglalhatja az Önre, az Ön preferenciáira és az Ön által használt eszközökre vonatkozó információkat is. Ezeket többnyire arra használjuk, hogy javítsuk az oldalainkat és azok az Ön igényei szerint működjenek. Az információk nem azonosítják Önt egyénként, de összességében segíthetnek abban, hogy a weboldalat az Ön igényeihez igazítsuk. Tiszteletben tartjuk az Ön magánélethez való jogát, és az alábbiakban található kiválasztással dönthet úgy, hogy bizonyos sütiket nem fogad el. Felhívjuk figyelmét, hogy egyes sütik letiltásával befolyásolhatja a weboldal működését és a megjelenített szolgáltatásokat.",
      "link": "A süti-nyilatkozat <a href=\"{hereLink}\">itt</a> található.",
      "items": {
        "technical": {
          "title": "Munkamenet sütik",
          "bodyText": "Ezek elengedhetetlenek az oldal működéséhez, ezért nem kapcsolhatók ki. Ezeket általában az Ön által végzett műveletekre válaszul hozzák létre, például a biztonsági beállításokkal kapcsolatos szolgáltatások igénylése, bejelentkezés, űrlapok kitöltése stb. esetén. Beállíthatja böngészőjét úgy, hogy blokkolja a sütiket, vagy értesítést küldjön a sütikről. Ezek a sütik nem tárolnak semmilyen azonosítható információt."
        },
        "functional": {
          "title": "Felhasználást elősegítő sütik",
          "bodyText": "Ezek a sütik hatékonyabbá és személyesebbé teszik az oldalt. Ezeket mi vagy olyan harmadik felek szolgáltatói állíthatják be, akiknek a szolgáltatásait a weboldalunkon használjuk. Ha nem engedélyezi ezeket a sütiket, előfordulhat, hogy bizonyos szolgáltatások nem fognak megfelelően működni."
        },
        "analytics": {
          "title": "Teljesítmény sütik",
          "bodyText": "Ezek a sütik a weboldal működésének javítására szolgálnak. Ezek teszik lehetővé számunkra, hogy azonosítsuk és nyomon kövessük a látogatók számát és a weboldal használatának módját. Segítenek nekünk a weboldal működésének javításában. Ezek a sütik nem gyűjtenek személyazonosításra alkalmas információkat."
        },
        "marketing": {
          "title": "Marketing sütik",
          "bodyText": "Ezeket a weboldal felhasználói preferenciáinak nyomon követésére használják a célzott reklámozás céljából, azaz marketing- és reklámüzenetek megjelenítésére (beleértve a harmadik felek webhelyeit is) a preferenciáknak megfelelően. A marketing süti fájlok külső társaságok eszközeit használják. Ezeket a marketing sütiket csak az Ön hozzájárulásával használjuk."
        }
      },
      "save": "Beállítások mentése"
    },
    "youtube": {
      "accept": "Elfogadom"
    }
  },
  "thematic_counselling": {
    "dashboard": {
      "title": "A megelőzésre összpontosítva"
    }
  },
  "placeholders": {
    "date": {
      "year": "ÉÉÉÉ",
      "month": "HH",
      "date": "NN"
    }
  },
  "putinSucks": {
    "menu": {
      "helpWith": "Hogyan működik a szolgáltatás?"
    },
    "infoTitle": "Hogyan működik a szolgáltatás?"
  },
  "releaseNotes": {
    "title": "Üdvözöljük a személyes egészségzónájában – Soulody.hu",
    "perex": "A hosszú, egészséges élet közelebb van, mint gondolná – csak az első lépést kell megtennie. Velünk a megelőzés a mindennapok természetes részévé válik, egyszerűen és átláthatóan. Vágjunk bele?",
    "content": [
      {
        "icon": "date-question",
        "text": "Mikor járt utoljára háziorvosnál, és mikor esedékes a következő látogatás? Adja meg az időpontot, mi pedig időben emlékeztetjük."
      },
      {
        "icon": "payment",
        "text": "Ellenőrizze, hogy naprakészek-e az oltásai. A kötelező és az ajánlott védőoltásokat egy helyen áttekintheti."
      },
      {
        "text": "Gyors egészségellenőrzés a végén személyre szabott ajánlással. Milyen a kapcsolata az alvással? Egy rövid teszt segít eligazodni.",
        "icon": "report"
      }
    ],
    "primaryButtonText": "Indulhat a megelőzés",
    "secondaryButtonText": "Kitöltöm a tesztet"
  },
  "healthInsuranceProviderBenefits": {
    "dashboard": {
      "title": "Az egészségbiztosító hozzájárulásai"
    },
    "title": "Válassza ki a biztosítótársaságát",
    "privateInsuranceProviders": "Magánbiztosítók",
    "publicInsuranceProviders": "Állami biztosítók",
    "showDetail": "Részletek megtekintése",
    "footer": {
      "updated": ""
    }
  },
  "explore": {
    "title": "Fedezze fel",
    "searchTitle": "Vissza a Fedezze fel-re",
    "subtitle": "Egészség szemmel és füllel: Tippek, podcastok, kedvezmények és még sok más",
    "stories": {
      "title": "Gyors tippek"
    },
    "articles": {
      "title": "Okosmagazin",
      "searchTitle": "Cikkek a témával kapcsolatban",
      "titleDetail": "Cikk részletei",
      "allChip": "Összes",
      "shareText": "Egy érdekes cikket küldök a Soulody.com-tól",
      "footer": {
        "title": "Eszébe jutott valamilyen kérdés a cikk olvasása közben, amit szívesen megkérdezne egy orvostól?",
        "textQuestion": "Örömmel válaszolunk bármely kérdésre, akár az Ön vagy családja egészségét, akár a cikket illetően.",
        "textQuestionOrder": "Örömmel válaszolunk bármely kérdésre, akár az Ön vagy családja egészségét, akár a cikket illetően. És ha szükséges, segítünk orvoshoz időpontot foglalni egész Magyarország területén."
      }
    },
    "consultations": {
      "titleDetail": "A kérdés részletei",
      "allChip": "Aktuálisan"
    }
  },
  "invitation": {
    "dashboard": {
      "title": "Hívja meg a családját",
      "text": "A Soulody.hu szolgáltatás a szerettei számára. Teljesen ingyenesen."
    },
    "title": "Egészség az egész családnak",
    "text": "Hívjon meg akár 5 közeli hozzátartozót. Önnek köszönhetően hozzátartozói keze ügyében lesz az orvosok és nővérek ingyenes online gondoskodása.",
    "list": [
      {
        "icon": "link",
        "text": "Másolja le az egyedi hivatkozást, hogy megoszthassa családjával."
      },
      {
        "icon": "rodina",
        "text": "Küldje el szeretteinek."
      },
      {
        "icon": "confetti",
        "text": "A regisztrációt követően a szolgáltatás ingyenesen aktiválódik."
      }
    ],
    "shareLink": "Megosztásra szánt hivatkozás",
    "copyCode": "Hivatkozás másolása",
    "codeCopied": "Másolva a",
    "familyTitle": "Kinek segítek"
  },
  "languageSwitcher": {
    "cz": "Čeština",
    "sk": "Slovenčina",
    "en": "English",
    "uk": "Українська",
    "ru": "Русский язык",
    "hu": "Magyar"
  },
  "medicalProcedure": {
    "notes": "Az Ön megjegyzései",
    "notesPlaceholder": "Adja hozzá személyes jegyzeteit ...",
    "uploadFiles": "Fájlok feltöltése",
    "content": {
      "content1": "Mi vár rám?",
      "content2": "Hogyan készüljek fel?",
      "content3": "A vizsgálat térítésmentes?",
      "content4": "Hogy kezdjen hozzá?",
      "content5": "Mikor kell elvégezni a vizsgálatot?",
      "content6": "Mit tegyek, ha valami nyugtalanító dolgot fedezek fel?",
      "content7": "Hogyan terjed?",
      "content8": "Van-e megelőzés?",
      "content9": "Milyen vakcinát válasszak?"
    },
    "boxes": {
      "recommended": "Ajánlott",
      "interval": "Gyakoriság",
      "showDetail": "Részletek megtekintése",
      "letsStart": "Kezdjük el",
      "noRecords": "Üres"
    },
    "examination": {
      "title": "A vizsgálat részletei",
      "add": "Szűrővizsgálat felvétele",
      "listTitle": "A vizsgálat részletei",
      "newFormPerex": "Jegyezze fel a látogatás időpontját. Jegyzeteket és fájlokat (fényképeket, orvosi jelentéseket stb.) is menthet.",
      "editFormPerex": "Itt szerkesztheti a dátumot, a jegyzeteket és kezelheti a kapcsolódó fájlokat.",
      "optional": "Önkéntes ellenőrzés",
      "recommended": "Szűrővizsgálat",
      "type": "Látogasson el a  oldalra",
      "nextBy": "Következő szűrővizsgálat",
      "next": "Következő szűrővizsgálat",
      "last": "Az utolsó turné",
      "new": "Új turné",
      "date": "A látogatás időpontja",
      "time": "A vizsgálat időpontja",
      "past": "Diplomás",
      "future": "Közelgő",
      "missedNotification": "A szűrővizsgálat előírt határidejét túllépte.",
      "emptyNotification": "Itt rögzítheti és kezelheti vizsgálatait.",
      "errorDateEmpty": "Kérjük, adja meg a látogatás dátumát.",
      "errorDateBoundsPast": "Kérjük, írja be annak a vizsgának az időpontját, amelyen már részt vett.",
      "errorDateBoundsFuture": "A határidőnek a jövőben kell lennie.",
      "todayDateCheckboxLabel": "A túrára ma került sor",
      "manageReports": "A vizsgálat részletei"
    },
    "vaccination": {
      "title": "Oltás részletezése",
      "add": "Oltások nyilvántartása",
      "newFormPerex": "Írja fel az oltás dátumát. Jegyzeteket és fájlokat (fényképeket, orvosi jelentéseket stb.) is menthet.",
      "editFormPerex": "Itt szerkesztheti a dátumot, a jegyzeteket és kezelheti a kapcsolódó fájlokat.",
      "optional": "Önkéntes védőoltás",
      "recommended": "Kötelező védőoltás",
      "type": "Oltások",
      "nextBy": "További védőoltások",
      "new": "Új védőoltások",
      "date": "Az oltás időpontja",
      "time": "Az oltás időpontja",
      "past": "Diplomás",
      "pastMulti": "Diplomás",
      "future": "Közelgő",
      "missedNotification": "A védőoltás előírt határidejét túllépte.",
      "emptyNotification": "Itt rögzítheti és kezelheti oltásait.",
      "errorDateEmpty": "Kérjük, adja meg az oltás dátumát.",
      "errorDateBoundsPast": "Kérjük, adja meg az oltás dátumát.",
      "errorDateBoundsFuture": "A határidőnek a jövőben kell lennie.",
      "todayDateCheckboxLabel": "Az oltásokat ma adták be",
      "errorTimeRequired": "Kérjük, töltse ki az oltás időpontját"
    },
    "trash": {
      "title": "Tényleg törölni szeretné a rekordot?",
      "text": "A rekord, beleértve a jegyzeteket és mellékleteket is, véglegesen törlésre kerül.",
      "keep": "Hagyja el a  címet",
      "delete": "Rekord törlése"
    }
  },
  "intervals": {
    "months": {
      "single": "hónap",
      "plural": "hónap",
      "semi": "hónap"
    },
    "years": {
      "single": "év",
      "plural": "év",
      "semi": "év"
    }
  },
  "feedback": {
    "title": "Hogy tetszik a Soulody.hu?",
    "text": "Az Ön értékelése a mi \"vitaminunk\". Önnek köszönhetően javítjuk az alkalmazás \"egészségét\".",
    "label": "Van valami ötleted a javításra?",
    "placeholder": "Itt elmondhatja nekünk...",
    "thankYou": {
      "title": "Köszönjük visszajelzését",
      "text": "&nbsp;Mindent megteszünk azért, hogy megkönnyítsük az egészséggel való törődést."
    },
    "menu": "Visszajelzés",
    "panelButton": "Kitölteni a visszajelzést"
  },
  "newsletterAgreement": {
    "dashboard": {
      "title": "Egészség e-mailben",
      "text": "Az újdonságokat és a kedvezményeket e-mailben küldjük el Önnek."
    },
    "title": "Küldünk egy üdvözletet a postaládájába",
    "perex": "Itt kezdődik az Ön hosszú távú egészséghez vezető útja.",
    "content": [
      {
        "icon": "confetti",
        "text": "Rendszeres tippek a jó közérzet fenntartásához."
      },
      {
        "icon": "care",
        "text": "Érdekes kedvezmények az egészségjavító segédeszközökre."
      },
      {
        "icon": "news",
        "text": "Értesítések az új cikkekről, amelyeket szívesen olvas."
      }
    ],
    "footer": {
      "text": "{link}A \"Feliratkozás\" gombra kattintva Ön elfogadja, hogy ."
    }
  },
  "bloodReport": {
    "infoStep": {
      "list": [
        {
          "icon": "register"
        },
        {
          "icon": "calendar/date-31"
        },
        {
          "icon": "doctor"
        }
      ],
      "serviceText": "\n A szolgáltatást az alábbi egészségügyi szolgáltatókon keresztül nyújtjuk Önnek: <br/>\n <br/>\n vérvétel és laboratóriumi eredmények elkészítése: <br/>\n Unilabs Diagnostics ks <br/>\n 2 székhellyel Ev89ropska /33b, Dejvice, 160 &nbsp; &nbsp; Prága &nbsp; 6 <br/>\n ID: 604 &nbsp; &nbsp; 488 <br/>\n a &nbsp; Városi Bíróság &nbsp; Prága sp. &nbsp; bélyegző &nbsp; És &nbsp; 76193 <br/>\n <br/>\n a laboratóriumi eredmények értelmezése: <br/>\n uLékaře.cz Health Care, sro <br/> <span class=\"notranslate\">__NEWLINE__R</span>, székhely: Českomoravská 2408/19ňa, 19ňa, &nbsp; &nbsp; Prága &nbsp; 9 <br/>\n ID: 096 &nbsp; &nbsp; 777 <br/>\n amelyet a prágai Városi Bíróságon tartottak. &nbsp; bélyegző &nbsp; C &nbsp; 339989\n ",
      "agreements": {
        "termsAndConditions": {
          "text": "Egyetértek {link} egészségügyi szolgáltatóval, az uLékaře.cz Health Care, s.r.o.",
          "linkText": "A Laboratóriumi eredmények értelmezése szolgáltatás nyújtásának feltételei"
        }
      }
    },
    "finalStep": {
      "title": "mi vár rád?",
      "text": "Köszönöm az információt. Segítenek az orvosoknak helyesen értékelni a vizsgálati eredményeket. Most átadjuk Önt az Unilabsnak – partnerlaboratóriumunknak.",
      "button": "Lépjen az Unilabs oldalra",
      "list": [
        {
          "title": "1. lépés",
          "text": "Laboratóriumi vizsgálatot választ"
        },
        {
          "title": "2. lépés",
          "text": "Lefoglalsz egy helyet és egy időpontot, jössz gyűjtésért"
        },
        {
          "title": "3. lépés",
          "text": "Az eredményeket az orvos magyarázatával együtt eljuttatjuk Önhöz"
        }
      ]
    }
  },
  "addressInput": {
    "country": "Állam",
    "postcode": "Irányítószám",
    "street": "Utca és házszám"
  },
  "videocall": {
    "chooseDate": "Válasszon időpontot",
    "confirmReservation": "Foglalás megerősítése",
    "reservationProgressing": "Ellenőrizzük",
    "dayOfWeek": [
      "Vas",
      "Hé",
      "Ke",
      "Sze",
      "Csü",
      "Pé",
      "Szo"
    ],
    "month": [
      "Január",
      "Február",
      "Március",
      "Április",
      "Május",
      "Június",
      "Július",
      "Augusztus",
      "Szeptember",
      "Október",
      "November",
      "December"
    ],
    "thankYou": {
      "info": "Minden szükséges információt elküldtünk Önnek e-mailben.",
      "success": "A videohívást sikeresen megterveztük 🎉",
      "close": "Bezárás"
    }
  },
  " profile": {
    "benefits": {
      "content_explore": {
        "chip": "Fedezze fel"
      }
    }
  },
  "profil": {
    "benefit": {
      "card": {
        "family": "Aktív (családtag)"
      }
    }
  },
  "homepage": {
    "header": {
      "nav": {
        "login": "Bejelentkezés",
        "link": [
          "Mivel foglalkozunk",
          "Miért a Soulody.hu",
          {},
          "Szolgáltatásunk"
        ]
      }
    },
    "footer": {
      "value": [
        "Emberiség.",
        "Lelkesedés.",
        "Szakértelem.",
        "Innováció."
      ],
      "about": "Világszerte a legegészségesebb munkakörnyezeteket hozzuk létre, és csúcsminőségű, adatvezérelt egészségügyi ellátást nyújtunk. \n      Hosszú távon és következetesen támogatjuk a vállalatokat alkalmazottaik egészségének megőrzésében.",
      "copyright": "Soulody"
    },
    "contact": {
      "mail": {
        "subject": "Fontos számunkra az Önök munkatársainak egészsége, hamarosan jelentkezünk",
        "content": "Szép napot kívánunk,<br/><br/>\nköszönjük érdeklődését a Cég egészsége és megelőzése szolgáltatás iránt. Örülünk, hogy törődnek munkatársaik egészségével. Legkésőbb a következő munkanapon felvesszük Önnel a kapcsolatot.<br/><br/>\n\nÜdvözlettel<br/><br/>\nMartin Čuba, Business Development Manager<br/>\ne-mail: <a href=\"mailto:partner@soulody.hu\">partner@soulody.hu</a><br/>\ntel.: <a href=\"tel:00420602413933\">+420 603 841 995</a>",
        "footer": {
          "copyright": "Soulody"
        }
      }
    }
  },
  "secondFactor": {
    "subtitleEmail": "Kétlépcsős azonosítás e-mailben",
    "label": "Adja meg a bejelentkezés megerősítéséhez kapott kódot.",
    "rememberDevice": "Ne kérjük ezen az eszközön",
    "sendAgain": "Kód újraküldése",
    "verify": "Kód ellenőrzése",
    "subtitleSms": "Kétlépcsős azonosítás SMS-ben",
    "error": {
      "input": "Adja meg a kódot.",
      "invalidCode": "Érvénytelen kód"
    }
  },
  "forms": {
    "Question": {
      "patient": {
        "title": "Alapvető információk",
        "whoisAsking": {
          "self": {
            "label": "Magamra"
          },
          "other": {
            "label": "Valaki másra"
          },
          "label": "Kire vonatkozik a kérdés?"
        },
        "firstName": {
          "self": {
            "label": "Utónév",
            "help": "Adja meg a valódi keresztnevét az egészségügyi szolgáltatóval való kommunikációhoz."
          },
          "other": {
            "label": "Érintett személy neve",
            "help": "Adja meg a valódi keresztnevét az egészségügyi szolgáltatóval való kommunikációhoz."
          }
        },
        "lastName": {
          "self": {
            "label": "Vezetéknév",
            "help": "Adja meg a valódi vezetéknevét az egészségügyi intézménnyel való kommunikációhoz."
          },
          "other": {
            "label": "Más személy vezetékneve",
            "help": "Adja meg a valódi vezetéknevét az egészségügyi intézménnyel való kommunikációhoz."
          }
        },
        "birthNumber": {
          "self": {
            "label": "Biztosítási szám",
            "help": "A biztosítási szám megkönnyíti számunkra, hogy időpontot adjunk a rendelőben."
          },
          "other": {
            "label": "Biztosítási szám",
            "help": "A biztosítási szám megkönnyíti számunkra, hogy időpontot adjunk a rendelőben."
          }
        },
        "birthDate": {
          "self": {
            "label": "Születési dátum"
          },
          "other": {
            "label": "A személy születési dátuma"
          }
        },
        "gender": {
          "self": {
            "label": "Neme",
            "help": "Válassza ki a nemét"
          },
          "other": {
            "label": "Neme",
            "help": "Válassza ki a nemét",
            "placeholder": "Válassza ki a nemét"
          }
        },
        "phone": {
          "self": {
            "label": "Telefonszám",
            "help": "Szükség esetén egy nővér fogja Önt felhívni."
          },
          "other": {
            "label": "Ennek a személynek a telefonszáma",
            "help": "Szükség esetén egy nővér fogja Önt felhívni."
          }
        },
        "address": {
          "self": {
            "label": "Cím",
            "help": "A cím segít megtalálni a megfelelő orvost."
          },
          "other": {
            "label": "Cím",
            "help": "A cím segít megtalálni a megfelelő orvost."
          }
        }
      },
      "questionBasic": {
        "title": "Írja le az egészségügyi problémáját.",
        "questionWhat": {
          "label": "Kérjük, írja le, ismertesse az egészségügyi problémát és annak minden tünetét. Minél részletesebben írja le, annál pontosabban fog válaszolni az orvos."
        },
        "questionHowWhen": {
          "label": "Hogyan és mikor (dátum) kezdődött a panasza? Ismétlődik? Hogyan alakul az idő múlásával?"
        },
        "questionPastExamination": {
          "label": "Történt-e orvosi vizsgálat, és milyen eredménnyel? Történt-e bármilyen kezelés, beleértve a házi kezelést is? Kérjük, írja le az alkalmazott kezelést és hatását."
        },
        "healthIssueQuestion": {
          "label": "Mit szeretne megkérdezni? Tegye fel kérdéseit az orvosnak, amelyek kapcsolódnak az Ön által leírt problémához."
        },
        "questionSolutionCountry": {
          "label": "Melyik országban van szüksége segítségre?"
        },
        "attachments": {
          "label": "Csatoljon fényképeket, orvosi jelentéseket és vizsgálati eredményeket.",
          "help": "Egy fájl mérete legfeljebb 20 MB lehet, az összes fájl együttesen legfeljebb 100 MB. A fájlokat .jpg, .png, pdf, mp3, avi vagy mp4 formátumban kérjük feltölteni."
        }
      },
      "questionAdditional": {
        "title": "További információk az orvosok számára",
        "questionAnotherSickness": {
          "self": {
            "label": "Kezelik Önt krónikus/egyéb betegséggel?"
          },
          "other": {
            "label": "Kezelik-e valamilyen krónikus vagy egyéb betegség miatt?"
          }
        },
        "questionAnotherSicknessDetails": {
          "self": {
            "label": "Kérem írja meg, milyen betegségei vannak."
          },
          "other": {
            "label": "Kérjük, írja le, hogy milyen betegséggel kezelik."
          }
        },
        "questionMedications": {
          "self": {
            "label": "Szed rendszeresen gyógyszert vagy gyógyhatású készítményt? Például fogamzásgátlót, inzulint, antidepresszánsokat…"
          },
          "other": {
            "label": "Szed-e rendszeresen valamilyen gyógyszert vagy gyógyszerkészítményt? Például: fogamzásgátlót, inzulint, antidepresszánsokat, stb."
          }
        },
        "questionMedicationsDetails": {
          "self": {
            "label": "Kérjük, adja meg az Ön által szedett gyógyszerek vagy gyógyszerkészítmények nevét és adagolását."
          },
          "other": {
            "label": "Kérjük, sorolja fel az Ön által szedett gyógyszerek vagy gyógyszerkészítmények nevét és adagolását."
          }
        },
        "questionAllergies": {
          "self": {
            "label": "Van valamilyen allergiája, különösen gyógyszerekre vagy gyógyászati készítményekre?"
          },
          "other": {
            "label": "Van-e valamire allergiája, különösen a gyógyszerekre vagy gyógyszerkészítményekre?"
          }
        },
        "questionAllergiesDetails": {
          "self": {
            "label": "Kérjük, írja meg, mire allergiás, és hogyan jelentkezik."
          },
          "other": {
            "label": "Kérjük, írja le, hogy mire allergiás, és hogyan jelentkezik Önnél az allergiája."
          }
        },
        "questionLifestyle": {
          "self": {
            "label": "Mi befolyásolhatja az egészségi állapotát? Pl. dohányzás, alkohol, túlsúly, egészségtelen életmód, megerőltető foglalkozás, stressz..."
          },
          "other": {
            "label": "Mi befolyásolhatja az egészségét? Pl. dohányzás, alkohol, túlsúly, egészségtelen életmód, megerőltető foglalkozás, stressz..."
          }
        },
        "questionContact": {
          "label": "Ha az orvos személyes találkozót javasol, szeretné-e, hogy egy nővér vegye fel Önnel a kapcsolatot, hogy felajánlja segítségét a találkozóval kapcsolatban?",
          "yes": "Igen, kapcsolatba akarok lépni a nővérrel.",
          "no": "Nem, nem akarom, hogy a nővér hívjon."
        }
      }
    },
    "Order": {
      "patient": {
        "title": "Alapvető információk",
        "whoisAsking": {
          "label": "Kit érint az időpontfoglalás?",
          "self": {
            "label": "Magamnak"
          },
          "other": {
            "label": "Más személy részére"
          }
        },
        "firstName": {
          "self": {
            "label": "Utónév",
            "help": "Adja meg a valódi keresztnevét az egészségügyi szolgáltatóval való kommunikációhoz."
          },
          "other": {
            "label": "Érintett személy neve",
            "help": "Adja meg a valódi keresztnevét az egészségügyi szolgáltatóval való kommunikációhoz."
          }
        },
        "lastName": {
          "self": {
            "label": "Vezetéknév",
            "help": "Adja meg a valódi vezetéknevét az egészségügyi intézménnyel való kommunikációhoz."
          },
          "other": {
            "label": "Más személy vezetékneve",
            "help": "Adja meg a valódi vezetéknevét az egészségügyi intézménnyel való kommunikációhoz."
          }
        },
        "birthNumber": {
          "self": {
            "label": "Biztosítási szám",
            "help": "A biztosítási szám megkönnyíti számunkra, hogy időpontot adjunk a rendelőben."
          },
          "other": {
            "label": "Biztosítási szám",
            "help": "A biztosítási szám megkönnyíti számunkra, hogy időpontot adjunk a rendelőben."
          }
        },
        "birthDate": {
          "self": {
            "label": "Születési dátum"
          },
          "other": {
            "label": "Más személy születési dátuma"
          }
        },
        "gender": {
          "self": {
            "label": "Neme",
            "help": "Válassza ki a nemét"
          },
          "other": {
            "label": "Neme",
            "help": "Válassza ki a nemét"
          }
        },
        "phone": {
          "self": {
            "label": "Telefonszám",
            "help": "Szükség esetén egy nővér fogja Önt felhívni."
          },
          "other": {
            "label": "Telefonszám",
            "help": "Szükség esetén egy nővér fogja Önt felhívni."
          }
        },
        "address": {
          "self": {
            "label": "Cím",
            "help": "A cím segít megtalálni a megfelelő orvost."
          },
          "other": {
            "label": "Más személy címe",
            "help": "A cím segít megtalálni a megfelelő orvost."
          }
        },
        "orderHealthInsurance": {
          "self": {
            "label": "Egészségbiztosító társaság",
            "help": "Olyan orvost keresünk, aki ezzel a biztosítótársasággal dolgozik."
          },
          "other": {
            "label": "Egészségbiztosító társaság",
            "help": "Olyan orvost keresünk, aki ezzel a biztosítótársasággal dolgozik."
          }
        }
      },
      "orderBasic": {
        "title": "Orvosi rendelés",
        "orderWhat": {
          "label": "Miben tudnak segíteni az ápolók?",
          "placeholder": "Például: új orvost találni, időpontot egyeztetni a jelenlegivel vagy tanácsot adni afelől, hogy hová forduljon, stb."
        },
        "orderSpecialist": {
          "label": "Milyen típusú orvost vagy szakembert keres?"
        },
        "attachments": {
          "label": "Csatolja a jelentkezési lapot vagy az orvosi jelentést, ha van ilyen.",
          "help": "Egy fájl mérete legfeljebb 20 MB lehet, az összes fájl együttesen legfeljebb 100 MB. A fájlokat .jpg, .png, pdf, mp3, avi vagy mp4 formátumban kérjük feltölteni."
        },
        "orderLocality": {
          "label": "Melyik helyen szeretne orvost találni?"
        },
        "orderTimeAvailability": {
          "label": "Melyik nap és időpont felel meg Önnek? Vagy nem?"
        },
        "orderContact": {
          "label": "Hogyan szeretne segíteni a megrendelésében?",
          "yes": "Jobban szeretem a teljes rendelést.",
          "no": "Én inkább a kontaktok küldését részesítem előnyben."
        }
      }
    },
    "goPrev": "Előző",
    "goNext": "Tovább",
    "submit": "Küldés"
  },
  "getApp": "Töltsd le az alkalmazást",
  "orderForm": {
    "thankYou": {
      "title": "A rendelés leadva.",
      "perex": "Köszönjük a rendelését. Amint feldolgozzuk, értesítést kap."
    }
  },
  "common": {
    "ok": "Folytatás"
  },
  "contactPage": {
    "customerService": {
      "items": [
        {
          "email": "info@soulody.com",
          "phone": "+36 1 765 4717"
        }
      ]
    },
    "otherContacts": {
      "items": [
        {
          "email": "info@soulody.com"
        }
      ]
    }
  },
  "selfReactivated": {
    "title": "Üdvözöljük újra!",
    "perex": "Fiókja ismét aktív, és örülünk, hogy továbbra is velünk törődik az egészségével. Amennyiben segítségre van szüksége, ügyfélszolgálatunk készséggel áll rendelkezésére az <a href=\"mailto:info@soulody.com\">info@soulody.com\n</a> e-mail-címen vagy a <a href=\"tel:003617654717\">+36 1 765 4717</a> telefonszámon.",
    "primaryButtonText": "Folytatás a Soulody.hu oldalon"
  },
  "ePrescription": {
    "title1": "Hogyan működik az eRecept",
    "perex": "Az orvos kérdéseket tesz fel, hogy felmérje az Ön egészségi állapotát. Ez alapján javasolhatja az e-recept kiállítását. Az e-receptre való jogosultság nem automatikus – az orvos csak akkor állítja ki, ha az biztonságos és indokolt.\nA Soulody.hu közvetlenül nem biztosítja e-receptek kiállítását, de összekötjük Önt olyan egészségügyi szakemberekkel, akiknek van jogosultságuk eReceptet kiállítani. Az eRecept kiállítása előtt felhívja Önt egy egészségügyi dolgozó adategyeztetés végett.",
    "disclaimerLink": "Több",
    "list": [
      {
        "title": "Mikor nem jár eRecept",
        "subtitle": "Például a következő esetekben:",
        "body": [
          "A kérdésből hiányoznak az eRecept kiállításához szükséges egészségügyi adatok.",
          "Mindenképp személyes orvosi vizsgálat szükséges.",
          "Az eset bonyolultabb vagy nem szokványos.",
          "A gyógyszert nem írhatja fel háziorvos, szakorvosra van szükség.",
          "Nem került sor a szükséges adategyeztetésre.",
          "A kérelem más személy részére szól (az eRecept nem kérhető partner, szülő, gyermek vagy más személy részére)."
        ]
      },
      {
        "title": "Hogyan működik",
        "body": [
          "Ön feltesz egy kérdést a fiókjában (megírhatja, hogy eRecept kiállítása érdekli).",
          "Az orvos ellenőrzi az Ön által megadott adatokat.",
          "Amennyiben indokolt, kiállítja az eReceptet.",
          "Mielőtt kiállítaná az eReceptet, egy egészségügyi nővér fogja Önt keresni adategyeztetés végett.",
          "Ha az eRecept nem állítható ki, tanácsot kap, hogy mit tegyen ezután – keressen fel pl. egy háziorvost vagy szakorvost."
        ]
      },
      {
        "title": "Mit jelent ez az Ön számára",
        "body": [
          "Tanácsadási felületünkön eRecept kiállítását is kérheti.",
          "A folyamat nem automatikusan jóváhagyott – mindig orvosnak kell ellenőriznie, hogy indokolt-e.",
          "Az eReceptet nem kapja meg azonnal – rövid feldolgozási idő szükséges.",
          "Szeretnénk a lehető legjobb segítséget nyújtani Önnek, azonban semmiképp nem a biztonságos ellátás kárára."
        ]
      },
      {
        "title": "Hogyan működik az eRecept külföldön",
        "subtitle": [
          "A cseh eRecept egyes tagországokban is alkalmazható: Lengyelország, Horvátország, Spanyolország, Görögország, Észtország, Finnország, Litvánia, Lettország.",
          "A gyógyszerek átvételéhez a következőkre lesz szüksége:"
        ],
        "body": [
          "érvényes személyazonossági okmány (személyi igazolvány vagy útlevél),"
        ],
        "footer": "A külföldön kiváltott gyógyszerek teljes áron fizetendők. Az esetleges térítést a saját egészségpénztáránál igényelheti."
      }
    ],
    "questionDisclaimerLink": "Több"
  },
  "medicalProcedures": {
    "prevention": [
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {
        "id": "e5b0c7b9-af38-4faa-bcf2-194e57b470c3",
        "icon": "doctor",
        "title": "Háziorvos (általános orvos)",
        "perex": "A háziorvosi ellátás vizsgálat az egészségügyi ellátás leglényegesebb része. A megelőző szűrővizsgálat terjedelme az Ön korától, betegségeitől és kockázati tényezőitől függ.",
        "expectation": "Az orvos látás-, hallás- és a bőrvizsgálatot végez, ellenőrzi az oltásokat, vérnyomást mér, megvizsgálja a szívet, a tüdőt, a pajzsmirigyet, a hasat és ellenőrzi az erek állapotát az alsó végtagokban.\nA háziorvosnál ajánlott évente 1-szer elvégezni egy alap vér- és vizeletvizsgálatot. A vérvizsgálat a zsírokra, a cukrokra, a vese- és májműködésre, valamint a szív- és érrendszerkeringési rendszer betegségeire összpontosít.\nA tüdőszűrés fiatalabb korban 3-5 évente ajánlott, 40 éves kortól évente térítésmentesen igénybe vehető. \nA szív- és érrendszeri betegségek kockázata 40 év felett ugrásszerűen növekszik, ezért fontos a szívműködési zavarok szűrővizsgálattal történő feltérképezése. Az orvos átfogó kockázatfelmérést végez, figyelembe véve az olyan kockázati tényezőket, mint az elhízás, a dohányzás, a magas vérnyomás, a magas koleszterinszint, mozgásszegény életmód stb. Ha szükséges, háziorvosa kardiológushoz utalhatja Önt.\n50 éves kortól székletvér (rejtettvér) vizsgálatot végeznek.\nAz 50 év felettieknek, különösen a nőknek, a csontritkulás kockázata miatt ajánlott a csontsűrűség mérése.\nA háziorvos szűrővizsgálatokat és további szükséges vizsgálatokat javasol.",
        "preparation": "A vérvételt megelőzően éjféltől ne fogyasszon semmit, és reggel is csak tiszta vizet igyon. A reggeli vizeletgyűjtés otthon is elvégezhető, egy steril edénybe, ún. középsugaras vizeletminta szükséges. Kérjük, a megelőző vizsgálatra körülbelül 30 percet szánjon.\nRészletes tájékoztatásért forduljon háziorvosához."
      },
      {
        "id": "57669704-32ce-4cb4-bd0c-5ef8fb5056e0",
        "icon": "tooth",
        "title": "Fogászati ellátás",
        "perex": "A megelőző fogászati szűrővizsgálat évente egyszer ajánlott, a szűrővizsgálatot az egészségbiztosító téríti. A megelőző fogászati ellátás magában foglalja a szájüregi rákszűrést is, amely a szájüregi egészségre és a szájüregi megelőzésére összpontosít, erre évente egyszer kerül sor. ",
        "expectation": "A fogorvos ellenőrzi a fogak, a nyálkahártyák, az íny és a fogágy állapotát. Felméri a szájhigiéniai állapotot, eltávolítja a fgkövet, szükség esetén professzionális dentálhigiénát javasol.",
        "preparation": "Az orvoslátogatás előtt mossa meg fogait, beleértve a fogközöket is. A megelőző vizsgálatra 15-30 percet szánjon."
      },
      {
        "id": "c7505b14-3c0e-4911-bd01-0c6659951ec0",
        "icon": "female-reproductive-system",
        "title": "Nőgyógyászat",
        "perex": "A vizsgálat során az orvos ellenőrzi a nő nemi szerveit, esetleg a melleket is.",
        "expectation": "A vizsgálat során az orvos ellenőrzi a személyes és családi anamnézist, az orvos általában megkérdezi az utolsó menstruáció időpontját. A nemi szerveket megtekintéssel, tapintással és ultrahanggal vizsgálja meg. A méhnyakrákszűrés (citológia) évente ajánlott a nemi élet megkezdésétől vagy 18 éves kortól.",
        "preparation": "Az orvosi kivizsgálás előtt végezze el az intim higiéniát.\nA megelőző vizsgálatra 15-30 percet szánjon.",
        "isItPaid": "A nőgyógyásznál végzett megelőző szűrővizsgálatokat az egészségbiztosító téríti, így Ön évente egy szűrővizsgálatra jogosult."
      },
      {
        "id": "d493f371-e92e-460b-a567-0d74e9f71ab3",
        "icon": "vulva",
        "title": "Méhnyakszűrés",
        "perex": "A méhnyak célja a méhnyakrák megelőzése. Ennek a vizsgálatnak köszönhetően más betegségek, például gyulladás vagy fertőzés is kimutatható.",
        "expectation": "A méhnyak felszínéről citológiai kenetvétellel kis mennyiségű sejtmintát vesznek. A mintát ezután citológiai vizsgálatra elküldik egy szaklaboratóriumba. Pozitív eredmény esetén a HPV-vírusokra vonatkozó vizsgálatot is elvégzik.",
        "preparation": "A szűrés a menstruációs vérzés kezdete után 10-22 nappal ajánlott.  \nA teljes megelőző vizsgálatra körülbelül 15 percet szánjon.",
        "isItPaid": "A 25 és 65 év közötti nők esetében a méhnyakrákszűrést az egészségbiztosítás 3 évente egyszer téríti. A részletekről érdeklődjön nőgyógyászánál."
      },
      {
        "id": "6c4734a7-637d-4843-a725-905aa6252659",
        "icon": "breasts",
        "title": "Emlőszűrés",
        "perex": "Az emlőszűrés egy mell- és hónaljvizsgálat, melynek célja a rák korai felfedezése. A szűrés magában foglalja a fizikális vizsgálatot tapintással és a mammográfiát.",
        "expectation": "A mammográfiai vizsgálat biztonságos és hatékony módszer. Kiváló minőségű röntgenképalkotást tesz lehetővé alacsony sugárterhelés mellett. A vizsgálatot álló testhelyzetben végzik, a mellet a készülékkel összenyomják, hogy minél több szövet váljon láthatóvá. A képeket készítő laboráns mindent elmagyaráz Önnek. Az orvos ellenőrzi és kiértékeli a felvételeket.",
        "preparation": "Nincs szükség felkészülésre, testápoló krémek és szilárd izzadásgátlók használata nem ajánlott.. A vizsgálat körülbelül 20 percig tart.",
        "isItPaid": "Az országosan szervezett szűrőprogram részeként a 45-65 év közötti nőket 2 évente hívják emlőszűrésre. A tapintásos önvizsgálat és ultrahangos emlőszűrés 20-45 éves kor között ajánlott.\nSzervezett emlőszűrést csak az egészségügyi hatóság által kijelölt Komplex Mammográfiás Központok (KMK) és Mammográfiás Szűrő Állomások (MSZÁ) végezhetnek.\nA részletekről érdeklődjön háziorvosánál."
      },
      {
        "id": "c0193a94-098d-4abf-a735-4e347d538f81",
        "icon": "rectum",
        "title": "Vastagbélszűrés",
        "perex": "A rendszeres vastagbélrákszűrés 50 éves kor felett mindkét nem számára ajánlott – a székletet okkult (rejtett) vérzésre vizsgálják. Ha az eredmény pozitív, az orvos beutalja Önt a szükséges szakorvosi vizsgálatokra.\n \nA szűrés fiatalabb korban is ajánlott, ha olyan krónikus bélbetegséget diagnosztizáltak esetükben, amely növeli a rák kockázatát, vagy ha a családban előfordult vastagbélrák.",
        "expectation": "A vastagbélrák-szűrővizsgálat során először laboratóriumban ellenőrzik a székletben lévő rejtett vért. A kezelőorvos ujjal végbélvizsgálatot is végezhet (rektális digitális vizsgálat).\n\nHa a székletvizsgálat eredménye pozitív, akkor vastagbéltükrözésre (kolonoszkópia) van szükség, ahol a kolonoszkóp segítségével a teljes vastagbél kivizsgálható. A kolonoszkópia során szövettani mintavételre és polipok eltávolítására is sor kerülhet. ",
        "preparation": "A vastagbéltükrözés előtt egy héttel célszerű diétát kezdeni, három nappal a beavatkozás előtt pépesített ételeket, a beavatkozás előtti napon csak folyadékot és hashajtó oldatot ajánlott fogyasztani, hogy a bél megtisztuljon az étel- és székletmaradványoktól.\nA vizsgálat körülbelül 20-30 percet vesz igénybe.\n\nA részletekről érdeklődjön háziorvosánál."
      },
      {
        "id": "96b2eb83-c7e6-4caf-bd87-06c6be80d79d",
        "icon": "eye",
        "title": "Szemészeti szűrővizsgálat",
        "perex": "A megelőző szemészeti vizsgálat során a szemész elsősorban olyan súlyos rendellenességek felderítésére összpontosít, amelyek nem fájnak, és az illető nem is tud róluk.",
        "expectation": "A szemész az egész szemet és a körülötte lévő struktúrákat is ellenőrzi, például a kötőhártyát és a szemhéjakat is. Megméri a látásélességet, megnézi, hogy szüksége van-e szemüvegre, megméri a szemnyomás értékét, és szemfenék vizsgálatot végez. Különös figyelmet kell fordítani a magas vérnyomásban és cukorbetegségben szenvedő betegekre, valamint azokra, akiknek a családjában már előfordultak szembetegségek, például szürke- vagy zöldhályog. További műszerek segítségével a szemmel kapcsolatos fénytörési hibákat részletesebben kivizsgálja, más betegségeket is felismerhet. A vizsgálat fájdalommentes, és meglehetősen egyszerű.",
        "preparation": "A vizsgálatra nem szükséges a felkészülés. A vizsgálat körülbelül 30 percig tart."
      },
      {
        "id": "9a828c68-7146-44fb-afed-b396df1418b1",
        "icon": "prostate",
        "title": "Prosztataszűrés",
        "perex": "A prosztatarák korai felismerése érdekében a férfiaknak 45 éves koruktól évente ajánlott a szűrés.",
        "expectation": "A prosztataszűrés a férfi nemi szervek ellenőrzésére irányuló vizsgálat. Az orvos fizikális vizsgálatot végez, és megvizsgálja a prosztatát. A szűrővizsgálat része egy vérvizsgálatot a prosztata-specifikus antigén (PSA) szintjének meghatározására, a prosztata tapintással történő vizsgálata a végbélen keresztül (rövid és fájdalommentes) és egy ultrahangvizsgálat. Ha szükséges, az orvos további vizsgálatokat javasol.",
        "preparation": "Az orvosi kivizsgálás előtt végezze el az intim higiéniát.\nA megelőző vizsgálatra körülbelül 20 percet szánjon.\nA részletekről érdeklődjön háziorvosánál."
      },
      {
        "id": "07344c6d-4d41-416d-8ba1-23b54bbab1c8",
        "icon": "dermatology",
        "title": "Anyajegyek vizsgálata",
        "perex": "Évente egyszer ajánlott az  anyajegyek vizsgálata bőrgyógyásznál dermatoszkóp segítségével. Ha nagyszámú anyajegye van, akkor félévente ajánlott a szűrővizsgálat. Az anyajegy színének, méretének vagy alakjának változása esetén azonnali bőrgyógyászati vizsgálat szükséges.",
        "expectation": "A bőrgyógyász ellenőrzi az egész bőrfelszínt, különösen az anyajegyeket. Gyanús képződmény esetén egy speciális optikai eszközzel, a dermatoszkóppal vizsgálja meg az anyajegyet. Ez a készülék sokkal nagyobb mértékben vizsgálja az anyajegyeket, és nagyítóként működik. A számítógéphez kapcsolva a korábbi felvételek összehasonlíthatók. Ha az anyajegy rákgyanús, az orvos kimetszi az anyajegyet, és mikroszkópos szövettani vizsgálatra küldi. Az esztétikailag zavaró vagy kellemetlen elhelyezésű (öv, melltartópánt alatt) anyajegyeket is eltávolítja.",
        "preparation": "A vizsgálatra nem szükséges a felkészülés. A vizsgálat körülbelül 20 percig tart, míg az anyajegyek eltávolítása miatt a látogatás hosszabb."
      },
      {
        "id": "f1de7b92-ac4f-4780-8974-ca76bd9fe548",
        "icon": "breasts-self-care",
        "title": "Mell önvizsgálat",
        "perex": "A mell önvizsgálata az egyik legegyszerűbb módszer az esetleges rák korai felismerésére. A vizsgálat egyszerű és csak néhány percet vesz igénybe. A rendszeres önvizsgálat nem helyettesíti a mammográfiás szűrővizsgálatot.",
        "how": "A vizsgálatkor álljon tükör elé; a nagymellű nőknek fekvő helyzetben ajánlott végezni a vizsgálatot Megtekintéssel ellenőrizze az esetleges különbségeket minden szemszögből - elölről, oldalról, előrehajolva.   A tényleges tapintást a vizsgált oldalon felemelt kézzel végezze, az ellenkező kézzel tapintva a mellet - a bal kéz vizsgálja a jobb mellet és fordítva. Ellenőrizze, hogy a mellek mérete, alakja nem változott-e meg, vizsgálja meg a mellbimbókat, enyhén nyomja meg. Figyelje meg, hogy ürül-e belőle váladék. Tapogassa meg a melleket felülről lefelé, majd a szegycsonttól oldalra, körkörös mozdulatokkal és a mellbimbótól minden oldalra ékelődő irányban. Ne feledkezzen meg a kulcscsont alatti területről és a hónaljról sem.",
        "when": "A vizsgálatot a menstruációs ciklus vége után, a ciklus ötödik-tizedik napján végezze el. Ha nincs menstruációja, válasszon ki egy napot havonta az önvizsgálatra.",
        "findConcerningQuestion": "Ha kétségei vannak, forduljon mielőbb nőgyógyászához, vagy kérje háziorvosa segítségét."
      },
      {
        "id": "78c17205-54df-4c04-ba35-e60a0a1571a4",
        "icon": "testicles",
        "title": "Herék önvizsgálata",
        "perex": "A hererák a 15-35 év közötti férfiak körében a leggyakoribb, és a daganat nagyon gyorsan keletkezik és terjed. Kezelhető, de korai felismerésre van szükség, ezért az önvizsgálatot nem szabad elhanyagolni, különösen ebben a korban.",
        "how": "A heréket a legjobb egy meleg zuhany után megvizsgálni, amikor a herezacskó bőre elernyedt. Vizsgálja és tapintsa is meg a heréit. Szemrevételezéssel és tapintással ellenőrizze, hogy a méretük és alakjuk nem változott-e meg, és hogy a bőrön nincsenek-e elváltozások, esetleg csomók. Tapogassa meg mindkét herét külön-külön mindkét kezével. A herék része a mellékhere is, ami az önvizsgálat során összezavarhatja. Mindkét oldalon szimmetrikusnak kell lenniük.",
        "when": "Célszerű legalább havonta egyszer elvégezni a vizsgálatot, különösen 15 és 35 éves kor között. Jelöljön ki egy napot a hónapban az önvizsgálatra.",
        "findConcerningQuestion": "Méret- vagy színváltozás, fájdalom, csomó tapintása vagy egyéb elváltozás esetén a lehető leghamarabb forduljon háziorvosához vagy urológusához."
      }
    ],
    "vaccination": [
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {
        "id": "7a5af7f0-bf15-4bfb-aef3-27ffa1a848be",
        "icon": "vaccine",
        "name": "Tetanusz",
        "perex": "A tetanusz, vagyis a merevgörcs súlyos betegség, amely különösen a fejlődő országokban gyakori halálok. A betegséget a Clostridium tetani baktérium okozza, amely általában az emberek és állatok, különösen a haszonállatok beleiben található.\nNapjainkra a betegség a lakosság beoltottságának köszönhetően szinte teljesen eltűnt.",
        "prevention": "A tetanusz elleni hatékony megelőzés a védőoltás. A vakcinát a szamárköhögés, a diftéria és a tetanusz elleni kombinált oltás részeként adják be a gyermekeknek. Az újraoltás 10 évente ajánlott, és különösen fontos az 50 év felettiek számára. Ellenőrizze háziorvosánál, hogy az oltása érvényes-e. ",
        "vaccineChoice": "Mivel a szamárköhögéses megbetegedések száma Európában emelkedik, felnőttkorban is ajánlott a tetanusz és szamárköhögés elleni kombinált védőoltással (pl. Boostrix, Boostrix Polio) történő újraoltás. A védőoltásokról konzultáljon háziorvosával."
      },
      {
        "id": "1d7fc631-396a-4cc5-8d23-db984805d499",
        "icon": "vaccine",
        "name": "Szamárköhögés",
        "perex": "A szamárköhögés egy rendkívül fertőző betegség, amelyet a Bordetella pertussis baktérium okoz. Találkozhatunk a „pertussis” elnevezéssel is. Világszerte elterjedt, és az utóbbi években egyre gyakoribbá vált. A legnagyobb kockázatot a 6 év alatti, be nem oltott gyermekek jelentik; a fertőzés azonban bármely életkorban előfordulhat.",
        "prevention": "A szamárköhögés elleni leghatékonyabb megelőzés a védőoltás. Az oltás a kötelező gyermekkori védőoltások közé tartozik, és a szamárköhögés, diftéria és tetanusz elleni kombinált vakcina része. Felnőttkorban ajánlott az emlékeztető oltás beadása, különösen a gyermekvállalást tervező vagy várandós kismamáknak.",
        "vaccineChoice": "Az Adacel, Boostrix vagy Boostrix Polio vakcinát ajánljuk. Tanácsért forduljon a háziorvosához."
      },
      {
        "id": "072bf9e7-4147-4471-98e4-50dc912ce689",
        "icon": "vaccine",
        "name": "Kanyaró, rubeola, mumpsz",
        "perex": "A kanyaró, mumpsz és rubeola rendkívül fertőző vírusos betegségek.",
        "prevention": "A védőoltás jelenti az egyetlen hatékony megelőzést. Gyermekkorban a kötelező védőoltás részeként adják be, a kanyaró, mumpsz és rubeola elleni kombinált vakcinával.\nFelnőttkorban lehetőség van egyszeri dózisú újraoltásra, ha Önt nem oltották be, vagy nem tudja, hogy beoltották-e, valamint a veszélyeztetett munkakörökben dolgozók számára is, továbbá ha Ön utazik, vagy fertőzött személlyel került kapcsolatba. A védőoltás a gyermekvállalást tervező vagy várandós kismamáknak ajánlott.",
        "vaccineChoice": "Javasoljuk például a Priorix vakcinát. Az oltás alkalmasságáról konzultáljon háziorvosával."
      },
      {
        "id": "27f03ee3-324f-4d20-8801-a6fdc99386c3",
        "icon": "vaccine",
        "name": "Vírusos hepatitis B (Vírusos májgyulladás B)",
        "perex": "A hepatitis B vírusos súlyos fertőző májbetegség. A betegség lehet akut, súlyos és krónikus is. Krónikus májgyulladást okoz, és májzsugorhoz vagy rosszindulatú májdaganathoz vezethet. A hepatitis B vírus sokkal fertőzőbb, mint a HIV. A betegség előfordulása világszerte elterjedt.",
        "prevention": "A hepatitis B vírus elleni hatékony megelőzés a védőoltás. Az oltás gyermekkorban kötelező, az általános iskola hetedik osztályában kerül rá sor. Azok a felnőttek is beolthatók, akiket gyermekkorukban nem oltottak be. Az oltás egészségügyi és szociális dolgozók, utazók és a fertőzés kockázatának kitett személyek számára is ajánlott. A hepatitis A vakcinával kombinálva is beoltható.",
        "vaccineChoice": "A rendelkezésre álló vakcinák hepatitis B ellen az Engerix B és a HB VacPro, illetve a Twinrix kombinált vakcina hepatitis A és B ellen. Konzultáljon háziorvosával a felnőttkori védőoltás megfelelőségéről. "
      },
      {
        "id": "d4d52911-9b27-4dd0-b13d-171c042d8219",
        "icon": "vaccine",
        "name": "Pneumococcus fertőzések",
        "perex": "A pneumococcus-fertőzés nagyon súlyos betegség. A Streptococcus pneumoniae gyermekeknél szepszist, tüdőgyulladást, agyhártyagyulladást vagy középfülgyulladást okozhat.",
        "prevention": "A pneumococcus megbetegedések ellen a leghatékonyabb megelőzés a védőoltás. A gyermekek számára kötelező a védőoltás, amelyet csecsemőkorban adnak be a diftéria, a szamárköhögés és a tetanusz, a gyermekbénulás és a Haemophilus influenzae B típusú fertőzés elleni védőoltásokkal együtt. A védőoltás felnőttkorban az 50 év felettiek, az immunkárosodottak, a léphiányosok, a dohányosok, a krónikus betegek, a gondozók és az egészségügyi dolgozók számára ajánlott.",
        "vaccineChoice": "A Prevenar 13 vagy a Pneumovax 23 vakcinát ajánljuk. Az oltás alkalmasságáról konzultáljon háziorvosával."
      },
      {
        "id": "6d7a157a-2947-48e2-a4b5-4fd8fff9bcb8",
        "icon": "vaccine",
        "name": "Tuberkulózis",
        "perex": "A tuberkulózis a Mycobacterium Tuberculosis baktérium által okozott súlyos fertőző betegség, amelyet nagyon hosszú és nehéz, több hónapig tartó, több antibiotikum kombinációjával történő kezeléssel lehet kezelni. Elsősorban a tüdőt, de az egész testet is érintheti. Magyarországon a gyermekek újszülöttkori védőoltása kötelező a miliáris tuberkulózis és a baziláris agyhártyagyulladás elleni védelem érdekében. ",
        "prevention": "A betegség elleni hatékony megelőzés a bőr alá adott védőoltás, szükséges, hogy az oltást képzett egészségügyi szakember adja be. A BCG vakcina élő vakcina.",
        "vaccineChoice": "Ha Önt gyermekkorában nem oltották be, konzultáljon háziorvosával a védőoltásokról. "
      },
      {
        "id": "2570c82e-a5ae-4cbc-8788-a80991b82f3c",
        "icon": "vaccine",
        "name": "Bárányhimlő",
        "perex": "A bárányhimlő a Varicella zoster vírus által terjesztett, rendkívül fertőző vírusos betegség. Gyermekkorban általában jól tolerálható, felnőtteknél a lefolyása drámai lehet. Minden korcsoportban fennáll a szövődmények, például agyvelőgyulladás, tüdőgyulladás, vérzéses állapotok kockázata. A fertőzés után a vírus a szervezetben marad, és a jövőben övsömör kialakulásához vezethet. A fertőzés különösen a várandós kismamák esetében veszélyes. ",
        "prevention": "A bárányhimlő elleni hatékony megelőzés a védőoltás. A betegség elmúlása után általában élethosszig tartó védettség is áll fenn. Magyarországon a védőoltás már kisgyermekkorban kötelező. Azokat az oltatlan gyermekeket, akik 13 éves korukig nem kapták meg a betegséget, szintén be kell oltani. A védőoltás felnőttek számára is ajánlott; a gyermekvállalást tervező nők számára legfeljebb 30 nappal a fogantatás előtt, csak abban az esetben, ha nem estek át a betegségen vagy nem kaptak védőoltást a múltban. A vakcina legyengített varicella vírust tartalmaz.",
        "vaccineChoice": "A védőoltásokról konzultáljon háziorvosával."
      },
      {
        "id": "e7ab691b-3998-4298-880f-01e86aebcbea",
        "icon": "vaccine",
        "name": "Influenza",
        "perex": "Az influenza fertőző vírusos betegség, amely minden évben a lakosság nagy részét érinti. Az idősek, a gyermekek és a krónikus betegek a legveszélyeztetebbek. A tünetek közé tartozik a rendkívüli fáradtság, láz, köhögés, fejfájás, izom- és- ízületi fájdalom. Az influenza többnyire télen fordul elő, és körülbelül 1-2 hét alatt kezelhető.",
        "prevention": "A megelőzés részeként célszerű egész évben erősíteni az immunrendszert egészséges életmóddal, kiegyensúlyozott étrenddel, vitamin bevitellel (lehetőleg gyümölcsök és zöldségek formájában), elegendő mozgással és alvással, esetleg hidegterápiával. Az évenkénti influenza elleni védőoltás is segít. A védőoltás ajánlott az idősek, az egészségügyi és szociális dolgozók, valamint a gondozók számára, és kimondottan előnyös a krónikus betegeknél és a várandós kismamáknál is. A védőoltás a gazdaságokban dolgozó vagy állatokat szállító személyek számára is ajánlott.",
        "vaccineChoice": "A rendelkezésre álló vakcinák a következők: 3Fluart, Fluarix, Vaxigrip, IDFlu és Agrippal. Háziorvosa segít kiválasztani a megfelelő védőoltást."
      },
      {
        "id": "4407a23f-1203-4474-bafb-31afa449992d",
        "icon": "vaccine",
        "name": "Covid-19",
        "perex": "A Covid-19 egy rendkívül fertőző betegség, amelyet koronavírusok más néven a SARS-CoV-2 okoz. A betegség előfordulása világszerte elterjedt. A betegség az általában enyhe felső légúti fertőzésként jelentkezik, amely nem igényel kórházi kezelést, de idősek vagy krónikus betegek esetében súlyos állapot is kialakulhat. Jelenleg az omikron variáns a domináns.",
        "prevention": "A Covid-19 megelőzésében különösen a megfelelő kézhigiénia, a nagy embercsoportok elkerülése, a maszk viselése és a saját immunrendszer erősítése játszik szerepet. Ötéves kortól adható a védőoltás. Felnőttek esetében a védőoltás különösen az egészségügyi és szociális dolgozók, a gondozók, a krónikus betegek, az immunhiányos betegek és a kórosan elhízottak számára ajánlott. Fertőzés esetén a védőoltás enyhítheti a betegség lefolyását. A vakcinát egy vagy két adagban adják be (a vakcina típusától függően). Mindenkinek ajánlott a 3. és 4. adaggal történő emlékeztető oltás. A vakcinát és az oltási ütemtervet a háziorvossal együttműködve kell kiválasztani a korábbi oltás típusának és az egészségi állapotnak megfelelően. ",
        "vaccineChoice": "Magyarországon jelenleg hatféle oltóanyag áll rendelkezésre, amelyek közül a Comirnaty (5 éves kortól kapható), a Spikevax vagy a Janssen oltóanyagokat ajánljuk. Az oltásra az EESZT foglalási rendszerében foglalhat időpontot, vagy a részt vevő egészségügyi intézményekben tartott oltási rendezvényeken kaphatja meg az oltást. A védőoltások és emlékeztető oltások ingyenesek az állampolgárok számára. Tanácsért forduljon a háziorvosához. "
      },
      {
        "id": "022f0448-7bb6-432a-b8d9-0c9a6ae1ca46",
        "icon": "vaccine",
        "name": "Hpv-fertőzés",
        "perex": "A HPV-fertőzés az egyik leggyakoribb szexuális betegség. A HPV-vírusoknak több mint 150 típusa ismert, amelyek közül néhány a fertőzés helyén szemölcsöket (condylomata) okozhat, 12 HPV-vírus pedig méhnyak-, pénisz-, végbél- és szájüregi rákot okozhat. A vírus könnyen terjed, és sok fertőzött ember tünetmentes, ezért a megelőzés különösen fontos.",
        "prevention": "A HPV-fertőzés megelőzése a biztonságos szex gyakorlása óvszerrel történő védekezéssel, és tanácsos elkerülni a szexuális partnerek gyakori váltogatását. Különösen a védőoltás hatékony megelőző intézkedés, amely egyben a rák megelőzésére is szolgál. A vakcina olyan férfiak és nők számára is alkalmas, akik még nem kaptak védőoltást, de azok számára is, akik már fertőzöttek valamelyik HPV-típussal. Ideális esetben a vakcinát a szexuális élet megkezdése előtt kell beadni, és a gyermekek az általános iskola 7. évfolyamában kaphatják meg az oltást. ",
        "vaccineChoice": "A Gardasil 9 vakcinát ajánljuk, kérjük, konzultáljon háziorvosával az oltásról. A védőoltás nem helyettesíti a nőgyógyászati szűrést!"
      },
      {
        "id": "cd8a7049-ad1c-4729-a9c8-bd13fd9f8989",
        "icon": "vaccine",
        "name": "Vírusos hepatitisz a",
        "perex": "A hepatitis A vírus fertőzéses akut májgyulladást okoz. Világszerte elterjedt, különösen az alacsony higiéniai színvonalú országokban. A betegség tünetmentes is lehet. Általában nem hagy maradandó hatást, nagyon ritkán májelégtelenség léphet fel.",
        "prevention": "A fertőzés megelőzhető a megfelelő személyi higiénia és a jó minőségű élelmiszer- és vízforrások bebiztosításával. A sárgaság elleni hatékony megelőzés a védőoltás, amelyet két adagban adnak be, az időtartam a 2 vakcina között a vakcina típusától függ. A hepatitis B elleni vakcinával kombinálva is beoltható. Az oltás ajánlott az alacsony higiéniai színvonalú területekre utazóknak, továbbá aholamikor fokozott fertőzésveszély áll fenn (egészségügyi dolgozók, szociális munkások, fertőzöttekkel kapcsolatba kerülő személyek).",
        "vaccineChoice": "Elérhetők a Havrix és az Avaxim, a kombinált hepatitis A + B elleni védőoltáshoz a Twinrix áll rendelkezésre. A védőoltásokról konzultáljon háziorvosával."
      },
      {
        "id": "650dd319-8c1d-4478-ad49-0a19dd23fe47",
        "icon": "vaccine",
        "name": "Kullancs által terjesztett agyvelőgyulladás",
        "perex": "A kullancs-encephalitis az ember központi idegrendszerét megtámadó vírusos betegség, amely két hullámban jelentkezik. A tünetek körülbelül egy héttel a kullancs csípés után jelentkeznek, és az influenzaszerű megbetegedésekhez hasonlítanak. Egy tünetmentes időszak után következik a második fázis, ekkor neurológiai tünetek jelentkeznek, melyek agyhártya- vagy agyvelőgyulladásra utalnak. A betegség tünetmentes is lehet.",
        "prevention": "Ha a szabadban tartózkodik, védje magát megfelelő ruházattal (hosszú ujjú felső és nadrág, magas szárú cipő), használjon kullancsriasztó szereket, és ellenőrizze a testét kullancsok után kutatva, miután a szabadban tartózkodott.\nA kullancs-encephalitiselleni hatékony megelőzés a védőoltás. A téli vakcinázás ideális. Az oltást három adagban adják be, majd három és öt év múlva szükséges az emlékeztető oltás beadása. A védőoltás a mezőgazdasági termelők, erdészek és a természetben gyakran tartózkodó emberek számára ajánlott. ",
        "vaccineChoice": "Az FSME-IMMUN vakcinát ajánljuk, de kapható az Encepur vakcina is. A megfelelő védőoltásokért forduljon tanácsért a háziorvosához."
      },
      {
        "id": "bb2fbde7-cb00-4e88-b04c-2fc2a1d99177",
        "icon": "vaccine",
        "name": "Meningococcus a, c, y, w-135",
        "perex": "A meningococcus fertőzés agyhártyagyulladást, vérmérgezést - szepszist okozhat, és akár halálhoz is vezethet. A betegség gyakran nagyon gyors és drámai lefolyású. Néhány óra alatt a teljesen egészséges szervezetben szervelégtelenség, akár halál is bekövetkezhet Az 5 év alatti gyermekek és a 26 év alatti fiatalok különösen veszélyeztetettek. Magyarországon a B és C típus dominál.",
        "prevention": "A meningococcus fertőzés ellen hatékony megelőzés a védőoltás. A vakcinát felnőtteknél egyszeri adagban adják be, de öt év elteltével emlékeztető oltás adandó be a már régóta oltott személyek, az utazók, a legyengült immunrendszerű személyek vagy a környéken kitört járvány esetén. A saját immunrendszer erősítése és az egészséges életmód fenntartása is ajánlott.",
        "vaccineChoice": "A Menveo vagy Nimenrix vakcinát ajánljuk. A védőoltásokról konzultáljon háziorvosával. "
      },
      {
        "id": "a7212519-1ecc-4bb8-8989-042b41665641",
        "icon": "vaccine",
        "name": "Meningococcus b",
        "perex": "A meningococcus fertőzés agyhártyagyulladást, vérmérgezést - szepszist okozhat, és akár halálhoz is vezethet. A betegség gyakran nagyon gyors és drámai lefolyású. Néhány óra alatt a teljesen egészséges szervezetben szervelégtelenség, akár halál is bekövetkezhet Az 5 év alatti gyermekek és a 26 év alatti fiatalok különösen veszélyeztetettek. Magyarországon a B és C típus dominál.",
        "prevention": "A meningococcus fertőzés ellen hatékony megelőzés a védőoltás. Ez egy két adagból álló vakcina, legalább egy hónapos időközzel, az emlékeztető oltás időzítése a vakcina típusától függ. Csecsemők és kisgyermekek, valamint felnőttek is beolthatók. A saját immunrendszer erősítése és az egészséges életmód fenntartása is ajánlott.",
        "vaccineChoice": "A Bexsero vakcinát ajánljuk. A védőoltásokról konzultáljon háziorvosával. "
      }
    ]
  },
  "questionPriceInfo": {
    "b2b": "Fizetni fogsz azért, ha kérdezel. {price} {currency}, egy napon belül megkapod az orvos válaszát {hours} h.",
    "b2cLink": "Részletes információk"
  }
}